<template>
    <div class="buySell-rightTop">
        <div class="showModal custom-modal" v-if="get_user.profile && get_user.profile.act_account_id" :style="(!advance && $route.name == 'custom-view')?'height: 100% !important;':''">
            <div v-if="tempOrderId == ''"><!--  class="h-100" -->
                <div class="buySell-popup text-center pt-1" v-if="Object.keys(instruments).length > 0 && instrument">
                    <p class="text-center currencyPath border-bottom px-2">
                        <span class="f-14 font-weight-bold">{{currency_pair}}</span>
                        <!-- <span :class="[{'green': (B - instrument.other.closepx) > 0,'red font-weight-bold': (B - instrument.other.closepx) < 0}]">
                            <span class="mr-1">{{parseFloat((B - instrument.other.closepx).toFixed(contractSize.length-1))}}</span>
                            ({{parseFloat((((B - instrument.other.closepx)/B)*100).toFixed(2))}}%)
                        </span> -->
                    </p>
                    <ul class="toggleButton w-100" v-if="modifyPending">
                        <li class="w-100">
                            <a href="javascript:void(0)">{{$t('modify_order') }}: <span>{{modifyPending}}</span></a>
                        </li>
                    </ul>
                    <ul class="btscure d-flex flex-wrap openOrder-list mb-1" v-if="positionDetails">	
						<li class="flex-column">{{$t('trade') }}  <span>#{{positionDetails.TradeID}}</span></li>
						<li class="flex-column">{{$t('type') }}  <span :class="sideClass[positionDetails.Side]">{{(parseInt(positionDetails.Side) == 1)?'Buy':'Sell'}}</span></li>
						<li class="flex-column">{{$t('price') }}  <span :class="sideClass[positionDetails.Side]"> {{positionDetails.Price}}</span></li>
						<li class="flex-column" v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">
                            {{$t('volume') }}  <span>{{Math.round(quantity * contractSize * 100) / 100}} {{$t('units') }} </span>
                        </li>
						<li class="flex-column" v-else>{{$t('volume') }}  <span>{{Math.round(quantity * 100) / 100}} {{$t('lot') }} </span></li>
					</ul>
                    <ul class="toggleButton d-inline-flex align-items-center justify-content-center" v-else-if="!modifyPending">
                        <li :class="(buySellType == 'sell')?'actives':' '">
                            <a @click="changeBuySell('sell',true);" class="redBG" href="javascript:void(0)">{{$t('sell')}} <span>{{B}}</span></a>
                        </li>
                        <li :class="(buySellType == 'buy')?'active':' '">
                            <a @click="changeBuySell('buy',true);" class="greenBG" href="javascript:void(0)">{{$t('buy')}} <span>{{A}}</span></a>
                        </li>
                    </ul>
                    <div class="mainContent buy" v-if="buySellType == 'buy' && !delay_lot">
                        <ul class="tabingPop d-flex align-items-center justify-content-center border-bottom" v-if="!modifyPending && !positionDetails">
                            <li :class="(buyType == 'M')?'active':' '">
                                <a @click="changeBuyType('M')" href="javascript:void(0)">{{$t('market')}}</a>
                            </li>
                            <li :class="(buyType == 'S')?'active':' '">
                                <a @click="changeBuyType('S')" href="javascript:void(0)">{{$t('buy_stop')}}</a>
                            </li>
                            <li :class="(buyType == 'L')?'active':' '">
                                <a @click="changeBuyType('L')" href="javascript:void(0)">{{$t('buy_limit')}}</a>
                            </li>
                        </ul>
                        <div class="tabpop-one scrollbar" v-if="buyType == 'M'">
                            <form class="marKet form-data" @submit="placeOrder()">
                                <div v-if="positionDetails"></div>
                                <div class="twoColmn" v-else>
                                    <div class="form-fields">
                                        <div class="d-flex align-items-center lightBC">
                                            <label>{{$t('price_level')}}</label>
                                            <input type="number" step="0.01" min="0" :placeholder="A" name="" disabled />
                                        </div>
                                    </div>
                                    <div class="form-fields-wrapper">
                                        <div class="form-fields" :class="[{'validation-error':submitted && errors.has('quantity')}]">
                                            <div class="d-flex align-items-center lightBC">
                                                <label v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">{{$t('quantity')}}({{$t('units') }})<sup class="red">*</sup></label>
                                                <label v-else>{{$t('quantity')}}({{$t('lots') }})<sup class="red">*</sup></label>
                                                <template  v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">
                                                    <input type="number" :step="getMinMaxUnits(0)" :min="getMinMaxUnits(0)" placeholder="1000" name="units" v-model="units" v-validate="{'required': true,'max_value':getMinMaxUnits(1),'min_value':getMinMaxUnits(0),'divisibleBy':getMinMaxUnits(0)}" autocomplete="off" ref="unitsInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',1,'units')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',0,'units')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                                <template  v-else>
                                                    <input type="number" :step="getMinMaxQuantity(0)" :min="getMinMaxQuantity(0)" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true,'max_value':getMinMaxQuantity(1),'min_value':getMinMaxQuantity(0),'divisibleBy':getMinMaxQuantity(0)}" autocomplete="off" ref="quantityInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                            </div>
                                            <span class="text-danger-error" v-if="submitted && errors.has('quantity')">
                                            	<span class="text-danger" v-if="errors.first('quantity').includes('decimal points')"> {{$t('quantity_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
                                        	</span>
                                            <span class="text-danger-error" v-if="submitted && errors.has('units')">
                                            	<span class="text-danger" v-if="errors.first('units').includes('decimal points')"> {{$t('units_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('units') }}</span>
                                        	</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="advanceoption" :class="[{'active':advance}]">
                                    <p @click="advance = !advance;openMarketLine();" class="f-12">
                                        {{$t('advanced_options')}}
                                        <feather class="ml-1" type="chevron-down" size="16px"></feather>
                                    </p>
                                    <div class="advShow" v-if="advance">
                                        <div class="twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox green">
                                                    {{$t('stop_loss')}} 
                                                    <input type="checkbox" v-model="edit_stop" @change="change_edit_stop()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields text-left" :class="[{'validation-error':submitted && errors.has('Stop loss')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_stop">*</sup></label>
                                                        <input type="number" :step="getStep(stop)" min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, lessThen : (A - pipAddition), greaterThen : 0}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
                                                    	<span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required') }}</span>
                                            			<span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('buy_stop_loss_error_message') }} </span>
                                            			<span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input class="decimal-restrict" type="number" step="1" min="0" placeholder="1.0" name="stop pip" v-model="stop_pip" :ref="'stop pipInput'" @keyup="keyUp($event,'stop_pip')">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',1,'stop_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',0,'stop_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('p_slash_l') }}</label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" max="0" placeholder="0.00" name="stop pnl" v-model="stop_pnl" :ref="'stop pnlInput'" @keyup="keyUp($event,'stop_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',1,'stop_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',0,'stop_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="boxlayOut">
                                                <label class="customCheckbox green">
                                                    {{$t('trailing_stop_loss')}} 
                                                    <input type="checkbox" v-model="edit_trail" @change="change_edit_trail()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Trail')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
                                                        <input type="number" min="1" placeholder="100" name="Trail" v-model="trail" v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_trail">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
                                                    	<span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greater_zero') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3 twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox green">
                                                    {{$t('take_profit')}} 
                                                    <input type="checkbox" v-model="edit_limit" @change="change_edit_limit()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('limit')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}} <sup class="red" v-if="edit_limit">*</sup></label>
                                                        <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, greaterThen : (Number(A) + Number(pipAddition))}" v-if="edit_limit" :ref="'Target PriceInput'" @keyup="keyUp($event,'limit')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_limit">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',1,'limit')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',0,'limit')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
                                                    	<span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_greater_trigger') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('limit') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input class="decimal-restrict" type="number" step="1" min="1" placeholder="1.0" name="limit pip" v-model="limit_pip" :ref="'limit pipInput'" @keyup="keyUp($event,'limit_pip')">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',1,'limit_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',0,'limit_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('p_slash_l') }}  </label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" min="0" placeholder="0.00" name="limit pnl" v-model="limit_pnl" :ref="'limit pnlInput'" @keyup="keyUp($event,'limit_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',1,'limit_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',0,'limit_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="twoColmn w-100 moreFields mt-1">
                                            <div class="form-fields transparent" :class="[{'validation-error':submitted && errors.has('Comment')}]">
                                                <div class="maximumChar">
                                                <p class="charterOnly mx-0 mb-1 d-flex align-items-center justify-content-between">{{$t('maximum_20_characters')}} <span class="green ml-2">{{comment.length}} / <span class="ltr-char">20</span></span> </p>
                                            </div>
                                                <textarea class="textarea" placeholder="Add Comment" maxlength="20" v-model="comment" name="Comment" v-validate="'max:20'"></textarea>
                                                <span class="text-danger mt-0" v-if="submitted && errors.has('Comment')">{{ errors.first('Comment') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :class="(modifyPending || positionDetails)?'d-flex':'fullWidh w-100 text-center mt-3'">
                                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-if="modifyPending || positionDetails">{{$t('modify') }}   {{positionDetails?'Trade':'Pending'}} </a>
                                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-else>{{$t('btn_place_buy_order')}} </a>
                                    <a href="javascript:void(0)" class="btn appButton mx-auto justify-content-center" @click.prevent="closeOrderWindow()" v-if="modifyPending || positionDetails"> {{$t('close') }}  </a>
                                </div>
                            </form>
                        </div>
                        <div class="tabpop-one scrollbar" v-if="buyType == 'S'">
                            <form class="marKet form-data" @submit="placeOrder()">
                                <div v-if="positionDetails"></div>
                                <div class="twoColmn" v-else>
                                    <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Price')}]">
                                        <div class="d-flex align-items-center lightBC">
                                            <label>{{$t('trigger_price') }} <sup class="red">*</sup></label>
                                            <input type="number" :step="getStep(price)" min="0" :placeholder="A" v-model="price" name="Price" v-validate="{'required':true, greaterThen : A}" ref="priceInput" @keyup="keyUp($event,'price')"/>
                                            <span class="addHighLow">
                                                <a href="javascript:void(0)" @click.stop="changeTick('priceInput',1,'price')"><feather type="plus"></feather> </a>
                                                <a href="javascript:void(0)" @click.stop="changeTick('priceInput',0,'price')"><feather type="minus"></feather> </a>
                                            </span>
                                        </div>
                                        <span class="text-danger-error" v-if="submitted && errors.has('Price')">
                                            <span class="text-danger" v-if="errors.first('Price').includes('decimal points')">{{$t('price_required') }} </span>
                                			<span class="text-danger" v-else-if="errors.first('Price').includes('is not valid')">{{$t('price_must_be_greater_than') }}  {{ A}}</span>
                                			<span class="text-danger" v-else>{{ errors.first('Price') }}</span>
                                		</span>
                                    </div>
                                    <div class="form-fields-wrapper">
                                        <div class="form-fields" :class="[{'validation-error':submitted && errors.has('quantity')}]">
                                            <div class="d-flex align-items-center lightBC">
                                                <label v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">{{$t('quantity')}}({{$t('units') }})<sup class="red">*</sup></label>
                                                <label v-else>{{$t('quantity')}}({{$t('lots') }})<sup class="red">*</sup></label>
                                                <template  v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">
                                                    <input type="number" :step="getMinMaxUnits(0)" :min="getMinMaxUnits(0)" placeholder="1000" name="units" v-model="units" v-validate="{'required': true,'max_value':getMinMaxUnits(1),'min_value':getMinMaxUnits(0),'divisibleBy':getMinMaxUnits(0)}" autocomplete="off" ref="unitsInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',1,'units')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',0,'units')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                                <template  v-else>
                                                    <input type="number" :step="getMinMaxQuantity(0)" :min="getMinMaxQuantity(0)" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true,'max_value':getMinMaxQuantity(1),'min_value':getMinMaxQuantity(0),'divisibleBy':getMinMaxQuantity(0)}" autocomplete="off" ref="quantityInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                            </div>
                                            <span class="text-danger-error" v-if="submitted && errors.has('quantity')">
                                            	<span class="text-danger" v-if="errors.first('quantity').includes('decimal points')"> {{$t('quantity_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
                                        	</span>
                                            <span class="text-danger-error" v-if="submitted && errors.has('units')">
                                            	<span class="text-danger" v-if="errors.first('units').includes('decimal points')"> {{$t('units_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('units') }}</span>
                                        	</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="advanceoption" :class="[{'active':advance}]">
                                    <p @click="advance = !advance" class="f-12">{{$t('advanced_options') }}  <feather class="ml-1" type="chevron-down" size="16px"></feather></p>
                                    <div class="advShow" v-if="advance">
                                        <div class="twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox green">
                                                    {{$t('stop_loss') }}
                                                    <input type="checkbox" v-model="edit_stop" @change="change_edit_stop()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Stop loss')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_stop">*</sup></label>
                                                        <input type="number" :step="getStep(stop)" min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, lessThen : (price - pipAddition), greaterThen : 0}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
                                                    	<span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('stop_loss_less_price_level_greater_zero') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input type="number" step="1" min="1" placeholder="1.0" name="stop pip" v-model="stop_pip" :ref="'stop pipInput'" @keyup="keyUp($event,'stop_pip')">
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',1,'stop_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',0,'stop_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('p_slash_l') }} </label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" max="0" placeholder="0.00" name="stop pnl" v-model="stop_pnl" :ref="'stop pnlInput'" @keyup="keyUp($event,'stop_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',1,'stop_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',0,'stop_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="boxlayOut">
                                                <label class="customCheckbox green">
                                                    {{$t('trailing_stop_loss')}} 
                                                    <input type="checkbox" v-model="edit_trail" @change="change_edit_trail()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Trail')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
                                                        <input type="number" min="1" placeholder="100" name="Trail" v-model="trail"v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_trail">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
                                                    	<span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greater_zero') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3 twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox green">
                                                    {{$t('take_profit')}} 
                                                    <input type="checkbox" v-model="edit_limit" @change="change_edit_limit()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('limit')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_limit">*</sup></label>
                                                        <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, greaterThen : (Number(price) + Number(pipAddition))}" v-if="edit_limit" :ref="'Target PriceInput'" @keyup="keyUp($event,'limit')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_limit">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',1,'limit')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',0,'limit')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
                                                    	<span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_greater_price_level') }} </span>
                                            			<span class="text-danger" v-else>{{ errors.first('limit') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input class="decimal-restrict" type="number" step="1" min="1" placeholder="1.0" name="limit pip" v-model="limit_pip" :ref="'limit pipInput'" @keyup="keyUp($event,'limit_pip')">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',1,'limit_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',0,'limit_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label> {{$t('p_slash_l') }} </label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" min="0" placeholder="0.00" name="limit pnl" v-model="limit_pnl" :ref="'limit pnlInput'" @keyup="keyUp($event,'limit_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',1,'limit_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',0,'limit_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="twoColmn w-100 moreFields mt-1">
                                            <div class="form-fields transparent" :class="[{'validation-error':submitted && errors.has('Comment')}]">
                                                <div class="maximumChar">
                                                <p class="charterOnly mx-0 mb-1 d-flex align-items-center justify-content-between">{{$t('maximum_20_characters')}}  <span class="green ml-2">{{comment.length}} / <span class="ltr-char">20</span></span> </p>
                                            </div>
                                                <textarea class="textarea" placeholder="Add Comment" maxlength="20" v-model="comment" name="Comment" v-validate="'max:20'"></textarea>
                                                <span class="text-danger mt-0" v-if="submitted && errors.has('Comment')">{{ errors.first('Comment') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :class="(modifyPending || positionDetails)?'d-flex':'fullWidh w-100 text-center mt-3'">
                                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-if="modifyPending || positionDetails">{{$t('modify') }}   {{positionDetails?'Trade':'Pending'}} </a>
                                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-else>{{$t('btn_place_buy_order')}} </a>
                                    <a href="javascript:void(0)" class="btn appButton mx-auto justify-content-center" @click.prevent="closeOrderWindow()" v-if="modifyPending || positionDetails"> {{$t('close') }}  </a>
                                </div>
                            </form>
                        </div>
                        <div class="tabpop-one scrollbar" v-if="buyType == 'L'">
                            <form class="marKet form-data" @submit="placeOrder()">
                                <div v-if="positionDetails"></div>
                                <div class="twoColmn" v-else>
                                    <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Price')}]">
                                        <div class="d-flex align-items-center lightBC">
                                            <label>{{$t('trigger_price') }} <sup class="red">*</sup></label>
                                            <input type="number" :step="getStep(price)" min="0" :placeholder="A" v-model="price" name="Price" v-validate="{'required':true, 'lessThen' : A, greaterThen:0}" ref="priceInput" @keyup="keyUp($event,'price')"/>
                                            <span class="addHighLow">
                                                <a href="javascript:void(0)" @click.stop="changeTick('priceInput',1,'price')"><feather type="plus"></feather> </a>
                                                <a href="javascript:void(0)" @click.stop="changeTick('priceInput',0,'price')"><feather type="minus"></feather> </a>
                                            </span>
                                        </div>
                                        <span class="text-danger-error" v-if="submitted && errors.has('Price')">
                                            <span class="text-danger" v-if="errors.first('Price').includes('decimal points')">{{$t('price_required') }} </span>
                                			<span class="text-danger" v-else-if="errors.first('Price').includes('is not valid')">{{$t('price_must_be_less_than') }}  {{ A}} {{$t('and_greater_than_zero') }} 0</span>
                                			<span class="text-danger" v-else>{{ errors.first('Price') }}</span>
                                		</span>
                                    </div>
                                    <div class="form-fields-wrapper">
                                        <div class="form-fields" :class="[{'validation-error':submitted && errors.has('quantity')}]">
                                            <div class="d-flex align-items-center lightBC">
                                                <label v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">{{$t('quantity')}}({{$t('units') }})<sup class="red">*</sup></label>
                                                <label v-else>{{$t('quantity')}}({{$t('lots') }})<sup class="red">*</sup></label>
                                                <template  v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">
                                                    <input type="number" :step="getMinMaxUnits(0)" :min="getMinMaxUnits(0)" placeholder="1000" name="units" v-model="units" v-validate="{'required': true,'max_value':getMinMaxUnits(1),'min_value':getMinMaxUnits(0),'divisibleBy':getMinMaxUnits(0)}" autocomplete="off" ref="unitsInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',1,'units')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',0,'units')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                                <template  v-else>
                                                    <input type="number" :step="getMinMaxQuantity(0)" :min="getMinMaxQuantity(0)" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true,'max_value':getMinMaxQuantity(1),'min_value':getMinMaxQuantity(0),'divisibleBy':getMinMaxQuantity(0)}" autocomplete="off" ref="quantityInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                            </div>
                                            <span class="text-danger-error" v-if="submitted && errors.has('quantity')">
                                            	<span class="text-danger" v-if="errors.first('quantity').includes('decimal points')"> {{$t('quantity_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
                                        	</span>
                                            <span class="text-danger-error" v-if="submitted && errors.has('units')">
                                            	<span class="text-danger" v-if="errors.first('units').includes('decimal points')"> {{$t('units_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('units') }}</span>
                                        	</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="advanceoption" :class="[{'active':advance}]">
                                    <p @click="advance = !advance" class="f-12">{{$t('advanced_options') }}   <feather class="ml-1" type="chevron-down" size="16px"></feather></p>
                                    <div class="advShow" v-if="advance">
                                        <div class="twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox green">
                                                    {{$t('stop_loss') }}  
                                                    <input type="checkbox" v-model="edit_stop" @change="change_edit_stop()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Stop loss')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_stop">*</sup></label>
                                                        <input type="number" :step="getStep(stop)" min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, 'lessThen' : (price - pipAddition), 'greaterThen' : 0}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
                                                    	<span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('stop_loss_less_price_level_greater_zero') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input type="number" step="1" min="1" placeholder="1.0" name="stop pip" v-model="stop_pip" :ref="'stop pipInput'" @keyup="keyUp($event,'stop_pip')">
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',1,'stop_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',0,'stop_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label> {{$t('p_slash_l') }}</label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" max="0" placeholder="0.00" name="stop pnl" v-model="stop_pnl" :ref="'stop pnlInput'" @keyup="keyUp($event,'stop_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',1,'stop_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',0,'stop_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="boxlayOut">
                                                <label class="customCheckbox green">
                                                    {{$t('trailing_stop_loss')}} 
                                                    <input type="checkbox" v-model="edit_trail" @change="change_edit_trail()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Trail')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('trailing_stop')}} <sup class="red" v-if="edit_trail">*</sup></label>
                                                        <input type="number" min="1" placeholder="100" name="Trail" v-model="trail"v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_trail">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
                                                    	<span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greater_zero') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3 twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox green">
                                                    {{$t('take_profit')}} 
                                                    <input type="checkbox" v-model="edit_limit" @change="change_edit_limit()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('limit')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_limit">*</sup></label>
                                                        <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, greaterThen : (Number(price) + Number(pipAddition))}" v-if="edit_limit" :ref="'Target PriceInput'" @keyup="keyUp($event,'limit')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_limit">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',1,'limit')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',0,'limit')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
                                                    	<span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_greater_price_level') }} </span>
                                            			<span class="text-danger" v-else>{{ errors.first('limit') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input class="decimal-restrict" type="number" step="1" min="1" placeholder="1.0" name="limit pip" v-model="limit_pip" :ref="'limit pipInput'" @keyup="keyUp($event,'limit_pip')">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',1,'limit_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',0,'limit_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('p_slash_l') }} </label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" min="0" placeholder="0.00" name="limit pnl" v-model="limit_pnl" :ref="'limit pnlInput'" @keyup="keyUp($event,'limit_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',1,'limit_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',0,'limit_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="twoColmn w-100 moreFields mt-1">
                                            <div class="form-fields transparent" :class="[{'validation-error':submitted && errors.has('Comment')}]">
                                                <div class="maximumChar">
                                                <p class="charterOnly mx-0 mb-1 d-flex align-items-center justify-content-between">{{$t('maximum_20_characters')}}  <span class="green ml-2">{{comment.length}} / <span class="ltr-char">20</span></span> </p>
                                            </div>
                                                <textarea class="textarea" placeholder="Add Comment" maxlength="20" v-model="comment" name="Comment" v-validate="'max:20'"></textarea>
                                                <span class="text-danger mt-0" v-if="submitted && errors.has('Comment')">{{ errors.first('Comment') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :class="(modifyPending || positionDetails)?'d-flex':'fullWidh w-100 text-center mt-3'">
                                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-if="modifyPending || positionDetails">{{$t('modify') }}   {{positionDetails?'Trade':'Pending'}} </a>
                                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-else>{{$t('btn_place_buy_order')}} </a>
                                    <a href="javascript:void(0)" class="btn appButton mx-auto justify-content-center" @click.prevent="closeOrderWindow()" v-if="modifyPending || positionDetails">{{$t('close') }}  </a>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="mainContent buy" v-if="buySellType == 'sell' && !delay_lot">
                        <ul class="tabingPop d-flex align-items-center justify-content-center border-bottom" v-if="!modifyPending && !positionDetails">
                            <li :class="(buyType == 'M')?'active':' '">
                                <a @click="changeBuyType('M')" href="javascript:void(0)">{{$t('market') }}</a>
                            </li>
                            <li :class="(buyType == 'S')?'active':' '">
                                <a @click="changeBuyType('S')" href="javascript:void(0)">{{$t('sell_stop') }} </a>
                            </li>
                            <li :class="(buyType == 'L')?'active':' '">
                                <a @click="changeBuyType('L')" href="javascript:void(0)">{{$t('sell_limit') }} </a>
                            </li>
                        </ul>
                        <div class="tabpop-one scrollbar" v-if="buyType == 'M'">
                            <form class="marKet form-data" @submit="placeOrder()">
                                <div v-if="positionDetails"></div>
                                <div class="twoColmn" v-else>
                                    <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Trail')}]">
                                        <div class="d-flex align-items-center lightBC">
                                            <label>Price Level</label>
                                            <input type="number" step="0.01" min="0" :placeholder="B" name="" disabled />
                                        </div>
                                    </div>
                                    <div class="form-fields-wrapper">
                                        <div class="form-fields" :class="[{'validation-error':submitted && errors.has('quantity')}]">
                                            <div class="d-flex align-items-center lightBC">
                                                <label v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">{{$t('quantity')}}({{$t('units') }})<sup class="red">*</sup></label>
                                                <label v-else>{{$t('quantity')}}({{$t('lots') }})<sup class="red">*</sup></label>
                                                <template  v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">
                                                    <input type="number" :step="getMinMaxUnits(0)" :min="getMinMaxUnits(0)" placeholder="1000" name="units" v-model="units" v-validate="{'required': true,'max_value':getMinMaxUnits(1),'min_value':getMinMaxUnits(0),'divisibleBy':getMinMaxUnits(0)}" autocomplete="off" ref="unitsInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',1,'units')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',0,'units')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                                <template  v-else>
                                                    <input type="number" :step="getMinMaxQuantity(0)" :min="getMinMaxQuantity(0)" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true,'max_value':getMinMaxQuantity(1),'min_value':getMinMaxQuantity(0),'divisibleBy':getMinMaxQuantity(0)}" autocomplete="off" ref="quantityInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                            </div>
                                            <span class="text-danger-error" v-if="submitted && errors.has('quantity')">
                                            	<span class="text-danger" v-if="errors.first('quantity').includes('decimal points')"> {{$t('quantity_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
                                        	</span>
                                            <span class="text-danger-error" v-if="submitted && errors.has('units')">
                                            	<span class="text-danger" v-if="errors.first('units').includes('decimal points')"> {{$t('units_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('units') }}</span>
                                        	</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="advanceoption" :class="[{'active':advance}]">
                                    <p @click="advance = !advance;openMarketLine();" class="f-12">{{$t('advanced_options') }} <feather class="ml-1" type="chevron-down" size="16px"></feather></p>
                                    <div class="advShow" v-if="advance">
                                        <div class="twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox red">
                                                    {{$t('stop_loss') }}
                                                    <input type="checkbox" v-model="edit_stop" @change="change_edit_stop()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Stop loss')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_stop">*</sup></label>
                                                        <input type="number" :step="getStep(stop)" min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, greaterThen : (Number(B) + Number(pipAddition))}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
                                                    	<span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required') }}</span>
                                            			<span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('sell_stop_loss_error_message') }} </span>
                                            			<span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input type="number" step="1" min="1" placeholder="1.0" name="stop pip" v-model="stop_pip" :ref="'stop pipInput'" @keyup="keyUp($event,'stop_pip')">
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',1,'stop_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',0,'stop_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label> {{$t('p_slash_l') }} </label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" max="0" placeholder="0.00" name="stop pnl" v-model="stop_pnl" :ref="'stop pnlInput'" @keyup="keyUp($event,'stop_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',1,'stop_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',0,'stop_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="boxlayOut">
                                                <label class="customCheckbox red">
                                                    {{$t('trailing_stop_loss')}} 
                                                    <input type="checkbox" v-model="edit_trail" @change="change_edit_trail()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Trail')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
                                                        <input type="number" min="1" placeholder="100" name="Trail" v-model="trail"v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_trail">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
                                                    	<span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greater_zero') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3 twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox red">
                                                    {{$t('take_profit')}} 
                                                    <input type="checkbox" v-model="edit_limit" @change="change_edit_limit()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('limit')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_limit">*</sup></label>
                                                        <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, lessThen : (B - pipAddition), greaterThen:0}" v-if="edit_limit" :ref="'Target PriceInput'" @keyup="keyUp($event,'limit')" @focus="pnl_focus = true" @blur="pnl_focus = false" />
                                                        <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_limit">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',1,'limit')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',0,'limit')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
                                                    	<span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_less_trigger') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('limit') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input class="decimal-restrict" type="number" step="1" min="1" placeholder="1.0" name="limit pip" v-model="limit_pip" :ref="'limit pipInput'" @keyup="keyUp($event,'limit_pip')">
                                                        <span class="addHighLow" v-if="edit_limit">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',1,'limit_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',0,'limit_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('p_slash_l') }} </label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" min="0" placeholder="0.00" name="limit pnl" v-model="limit_pnl" :ref="'limit pnlInput'" @keyup="keyUp($event,'limit_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',1,'limit_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',0,'limit_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="twoColmn w-100 moreFields mt-1">
                                            <div class="form-fields transparent" :class="[{'validation-error':submitted && errors.has('Comment')}]">
                                                <div class="maximumChar">
                                                <p class="charterOnly mx-0 mb-1 d-flex align-items-center justify-content-between ">{{$t('maximum_20_characters')}}  <span class="green ml-2">{{comment.length}} / <span class="ltr-char">20</span></span> </p>
                                            </div>
                                                <textarea class="textarea" placeholder="Add Comment" maxlength="20" v-model="comment" name="Comment" v-validate="'max:20'"></textarea>
                                                <span class="text-danger mt-0" v-if="submitted && errors.has('Comment')">{{ errors.first('Comment') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :class="(modifyPending || positionDetails)?'d-flex':'fullWidh w-100 text-center mt-3'">
                                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-if="modifyPending || positionDetails">{{$t('modify') }}  {{positionDetails?'Trade':'Pending'}} </a>
                                    <a href="javascript:void(0)" class="btn appButton redBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-else> {{$t('btn_place_sell_order')}} </a>
                                    <a href="javascript:void(0)" class="btn appButton mx-auto justify-content-center" @click.prevent="closeOrderWindow()" v-if="modifyPending || positionDetails">{{$t('close') }}  </a>
                                </div>
                            </form>
                        </div>
                        <div class="tabpop-one scrollbar" v-if="buyType == 'S'">
                            <form class="marKet form-data" @submit="placeOrder()">
                                <div v-if="positionDetails"></div>
                                <div class="twoColmn" v-else>
                                    <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Price')}]">
                                        <div class="d-flex align-items-center lightBC">
                                            <label>Trigger price<sup class="red">*</sup></label>
                                            <input type="number" :step="getStep(price)" min="0" :placeholder="instrument.other.closepx" v-model="price" name="Price" v-validate="{'required':true, 'lessThen' : B, greaterThen:0}" ref="priceInput" @keyup="keyUp($event,'price')"/>
                                            <span class="addHighLow">
                                                <a href="javascript:void(0)" @click.stop="changeTick('priceInput',1,'price')"><feather type="plus"></feather> </a>
                                                <a href="javascript:void(0)" @click.stop="changeTick('priceInput',0,'price')"><feather type="minus"></feather> </a>
                                            </span>
                                        </div>
                                        <span class="text-danger-error" v-if="submitted && errors.has('Price')">
                                            <span class="text-danger" v-if="errors.first('Price').includes('decimal points')">{{$t('price_required') }}</span>
                                			<span class="text-danger" v-else-if="errors.first('Price').includes('is not valid')">{{$t('price_must_be_less_than') }}  {{ B}} {{$t('and_greater_than_zero') }} 0</span>
                                			<span class="text-danger" v-else>{{ errors.first('Price') }}</span>
                                		</span>
                                    </div>
                                    <div class="form-fields-wrapper">
                                        <div class="form-fields" :class="[{'validation-error':submitted && errors.has('quantity')}]">
                                            <div class="d-flex align-items-center lightBC">
                                                <label v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">{{$t('quantity')}}({{$t('units') }})<sup class="red">*</sup></label>
                                                <label v-else>{{$t('quantity')}}({{$t('lots') }})<sup class="red">*</sup></label>
                                                <template  v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">
                                                    <input type="number" :step="getMinMaxUnits(0)" :min="getMinMaxUnits(0)" placeholder="1000" name="units" v-model="units" v-validate="{'required': true,'max_value':getMinMaxUnits(1),'min_value':getMinMaxUnits(0),'divisibleBy':getMinMaxUnits(0)}" autocomplete="off" ref="unitsInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',1,'units')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',0,'units')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                                <template  v-else>
                                                    <input type="number" :step="getMinMaxQuantity(0)" :min="getMinMaxQuantity(0)" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true,'max_value':getMinMaxQuantity(1),'min_value':getMinMaxQuantity(0),'divisibleBy':getMinMaxQuantity(0)}" autocomplete="off" ref="quantityInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                            </div>
                                            <span class="text-danger-error" v-if="submitted && errors.has('quantity')">
                                                <span class="text-danger" v-if="errors.first('quantity').includes('decimal points')"> {{$t('quantity_required') }}</span>
                                                <span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
                                            </span>
                                            <span class="text-danger-error" v-if="submitted && errors.has('units')">
                                                <span class="text-danger" v-if="errors.first('units').includes('decimal points')"> {{$t('units_required') }}</span>
                                                <span class="text-danger" v-else>{{ errors.first('units') }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="advanceoption" :class="[{'active':advance}]">
                                    <p @click="advance = !advance" class="f-12">{{$t('advanced_options') }}  <feather class="ml-1" type="chevron-down" size="16px"></feather></p>
                                    <div class="advShow" v-if="advance">
                                        <div class="twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox red">
                                                    {{$t('stop_loss') }}
                                                    <input type="checkbox" v-model="edit_stop" @change="change_edit_stop()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Stop loss')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}} <sup class="red" v-if="edit_stop">*</sup></label>
                                                        <input type="number" :step="getStep(stop)" min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, greaterThen : (Number(price) + Number(pipAddition))}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
                                                    	<span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('sell_stop_loss_greater_trigger_price') }} </span>
                                            			<span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input type="number" step="1" min="1" placeholder="1.0" name="stop pip" v-model="stop_pip" :ref="'stop pipInput'" @keyup="keyUp($event,'stop_pip')">
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',1,'stop_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',0,'stop_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('p_slash_l') }} </label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" max="0" placeholder="0.00" name="stop pnl" v-model="stop_pnl" :ref="'stop pnlInput'" @keyup="keyUp($event,'stop_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',1,'stop_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',0,'stop_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="boxlayOut">
                                                <label class="customCheckbox red">
                                                    {{$t('trailing_stop_loss')}} 
                                                    <input type="checkbox" v-model="edit_trail" @change="change_edit_trail()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Trail')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
                                                        <input type="number" min="1" placeholder="100" name="Trail" v-model="trail"v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_trail">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
                                                    	<span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required')}} </span>
                                            			<span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greater_zero')}} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3 twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox red">
                                                    {{$t('take_profit')}} 
                                                    <input type="checkbox" v-model="edit_limit" @change="change_edit_limit()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('limit')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_limit">*</sup></label>
                                                        <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, lessThen : (price - pipAddition), greaterThen:0}" v-if="edit_limit" :ref="'Target PriceInput'" @keyup="keyUp($event,'limit')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_limit">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',1,'limit')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',0,'limit')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
                                                    	<span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required') }}</span>
                                            			<span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">
                                                            {{$t('target_price_must_less_than_trigger_price_greater_zero') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('limit') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input class="decimal-restrict" type="number" step="1" min="1" placeholder="1.0" name="limit pip" v-model="limit_pip" :ref="'limit pipInput'" @keyup="keyUp($event,'limit_pip')">
                                                        <span class="addHighLow" v-if="edit_limit">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',1,'limit_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',0,'limit_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('p_slash_l') }}</label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" min="0" placeholder="0.00" name="limit pnl" v-model="limit_pnl" :ref="'limit pnlInput'" @keyup="keyUp($event,'limit_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',1,'limit_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',0,'limit_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="twoColmn w-100 moreFields mt-1">
                                            <div class="form-fields transparent" :class="[{'validation-error':submitted && errors.has('Comment')}]">
                                                <div class="maximumChar">
                                                <p class="charterOnly mx-0 mb-1 d-flex align-items-center justify-content-between">{{$t('maximum_20_characters')}}  <span class="green ml-2">{{comment.length}} / <span class="ltr-char">20</span></span> </p>
                                            </div>
                                                <textarea class="textarea" placeholder="Add Comment" maxlength="20" v-model="comment" name="Comment" v-validate="'max:20'"></textarea>
                                                <span class="text-danger mt-0" v-if="submitted && errors.has('Comment')">{{ errors.first('Comment') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :class="(modifyPending || positionDetails)?'d-flex':'fullWidh w-100 text-center mt-3'">
                                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-if="modifyPending || positionDetails">{{$t('modify') }}  {{positionDetails?'Trade':'Pending'}} </a>
                                    <a href="javascript:void(0)" class="btn appButton redBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-else> {{$t('btn_place_sell_order')}} </a>
                                    <a href="javascript:void(0)" class="btn appButton mx-auto justify-content-center" @click.prevent="closeOrderWindow()" v-if="modifyPending || positionDetails">{{$t('close') }}  </a>
                                </div>
                            </form>
                        </div> 
                        <div class="tabpop-one scrollbar" v-if="buyType == 'L'">
                            <form class="marKet form-data" @submit="placeOrder()">
                                <div v-if="positionDetails"></div>
                                <div class="twoColmn" v-else>
                                    <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Price')}]">
                                        <div class="d-flex align-items-center lightBC">
                                            <label>Trigger Price<sup class="red">*</sup></label>
                                            <input type="number" :step="getStep(price)" min="0" :placeholder="instrument.other.closepx" v-model="price" name="Price" v-validate="{'required':true, 'greaterThen' : A}" ref="priceInput" @keyup="keyUp($event,'price')"/>
                                            <span class="addHighLow">
                                                <a href="javascript:void(0)" @click.stop="changeTick('priceInput',1,'price')"><feather type="plus"></feather> </a>
                                                <a href="javascript:void(0)" @click.stop="changeTick('priceInput',0,'price')"><feather type="minus"></feather> </a>
                                            </span>
                                        </div>
                                        <span class="text-danger-error" v-if="submitted && errors.has('Price')">
                                            <span class="text-danger" v-if="errors.first('Price').includes('decimal points')">{{$t('price_required') }}</span>
                                			<span class="text-danger" v-else-if="errors.first('Price').includes('is not valid')">{{$t('price_must_be_greater_than') }}  {{ A }}.</span>
                                			<span class="text-danger" v-else>{{ errors.first('Price') }}</span>
                                		</span>
                                    </div>
                                    <div class="form-fields-wrapper">
                                        <div class="form-fields" :class="[{'validation-error':submitted && errors.has('quantity')}]">
                                            <div class="d-flex align-items-center lightBC">
                                                <label v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">{{$t('quantity')}}({{$t('units') }})<sup class="red">*</sup></label>
                                                <label v-else>{{$t('quantity')}}({{$t('lots') }})<sup class="red">*</sup></label>
                                                <template  v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">
                                                    <input type="number" :step="getMinMaxUnits(0)" :min="getMinMaxUnits(0)" placeholder="1000" name="units" v-model="units" v-validate="{'required': true,'max_value':getMinMaxUnits(1),'min_value':getMinMaxUnits(0),'divisibleBy':getMinMaxUnits(0)}" autocomplete="off" ref="unitsInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',1,'units')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('unitsInput',0,'units')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                                <template  v-else>
                                                    <input type="number" :step="getMinMaxQuantity(0)" :min="getMinMaxQuantity(0)" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true,'max_value':getMinMaxQuantity(1),'min_value':getMinMaxQuantity(0),'divisibleBy':getMinMaxQuantity(0)}" autocomplete="off" ref="quantityInput" />
                                                    <span class="addHighLow">
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                                        <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                                    </span>
                                                </template>
                                            </div>
                                            <span class="text-danger-error" v-if="submitted && errors.has('quantity')">
                                            	<span class="text-danger" v-if="errors.first('quantity').includes('decimal points')"> {{$t('quantity_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
                                        	</span>
                                            <span class="text-danger-error" v-if="submitted && errors.has('units')">
                                            	<span class="text-danger" v-if="errors.first('units').includes('decimal points')"> {{$t('units_required') }}</span>
                                            	<span class="text-danger" v-else>{{ errors.first('units') }}</span>
                                        	</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="advanceoption" :class="[{'active':advance}]">
                                    <p @click="advance = !advance" class="f-12">{{$t('advanced_options') }}  <feather class="ml-1" type="chevron-down" size="16px"></feather></p>
                                    <div class="advShow" v-if="advance">
                                        <div class="twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox red">
                                                  {{$t('stop_loss') }}
                                                    <input type="checkbox" v-model="edit_stop" @change="change_edit_stop()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Stop loss')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_stop">*</sup></label>
                                                        <input type="number" :step="getStep(stop)" min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, greaterThen : (Number(price) + Number(pipAddition))}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
                                                    	<span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required') }}</span>
                                            			<span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('sell_stop_loss_error_message') }}</span>
                                            			<span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input type="number" step="1" min="1" placeholder="1.0" name="stop pip" v-model="stop_pip" :ref="'stop pipInput'" @keyup="keyUp($event,'stop_pip')">
                                                        <span class="addHighLow" v-if="edit_stop">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',1,'stop_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pipInput',0,'stop_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_stop">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('p_slash_l') }} </label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" max="0" placeholder="0.00" name="stop pnl" v-model="stop_pnl" :ref="'stop pnlInput'" @keyup="keyUp($event,'stop_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',1,'stop_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('stop pnlInput',0,'stop_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="boxlayOut">
                                                <label class="customCheckbox red">
                                                    {{$t('trailing_stop_loss')}} 
                                                    <input type="checkbox" v-model="edit_trail" @change="change_edit_trail()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('Trail')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
                                                        <input type="number" min="1" placeholder="100" name="Trail" v-model="trail"v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_trail">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
                                                    	<span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greater_zero') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3 twoColmn moreFields">
                                            <div class="boxlayOut">
                                                <label class="customCheckbox red">
                                                    {{$t('take_profit')}} 
                                                    <input type="checkbox" v-model="edit_limit" @change="change_edit_limit()"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div class="form-fields" :class="[{'validation-error':submitted && errors.has('limit')}]">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('price')}}<sup class="red" v-if="edit_limit">*</sup></label>
                                                        <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, lessThen : (price - pipAddition), greaterThen:0}" v-if="edit_limit" :ref="'Target PriceInput'" @keyup="keyUp($event,'limit')" @focus="pnl_focus = true" @blur="pnl_focus = false"/>
                                                        <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
                                                        <span class="addHighLow" v-if="edit_limit">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',1,'limit')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('Target PriceInput',0,'limit')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                    <span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
                                                    	<span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required') }} </span>
                                            			<span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_less_trigger') }} 0</span>
                                            			<span class="text-danger" v-else>{{ errors.first('limit') }}</span>
                                                    </span>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('distance_points') }}</label>
                                                        <span class="ml-2 f-14">{{$t('points') }}</span>
                                                        <input class="decimal-restrict" type="number" step="1" min="1" placeholder="1.0" name="limit pip" v-model="limit_pip" :ref="'limit pipInput'" @keyup="keyUp($event,'limit_pip')">
                                                        <span class="addHighLow" v-if="edit_limit">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',1,'limit_pip')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pipInput',0,'limit_pip')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-fields text-left" v-if="edit_limit">
                                                    <div class="d-flex align-items-center lightBC">
                                                        <label>{{$t('p_slash_l') }}  </label>
                                                        <span class="ml-2 f-14 green-color"> {{ currency }}</span>
                                                        <input class="no-price-update" type="number" step="1" min="0" placeholder="0.00" name="limit pnl" v-model="limit_pnl" :ref="'limit pnlInput'" @keyup="keyUp($event,'limit_pnl')" @focus="pnl_focus = true" @blur="pnl_focus = false">
                                                        <span class="addHighLow">
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',1,'limit_pnl')"><feather type="plus"></feather> </a>
                                                            <a href="javascript:void(0)" @click.prevent="changeTick('limit pnlInput',0,'limit_pnl')"><feather type="minus"></feather> </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="twoColmn w-100 moreFields mt-1">
                                            <div class="form-fields transparent" :class="[{'validation-error':submitted && errors.has('Comment')}]">
                                                <div class="maximumChar">
                                                <p class="charterOnly mx-0 mb-1 d-flex align-items-center justify-content-between ">{{$t('maximum_20_characters')}}  <span class="green ml-2">{{comment.length}} / <span class="ltr-char">20</span></span> </p>
                                            </div>
                                                <textarea class="textarea" placeholder="Add Comment" maxlength="20" v-model="comment" name="Comment" v-validate="'max:20'"></textarea>
                                                <span class="text-danger mt-0" v-if="submitted && errors.has('Comment')">{{ errors.first('Comment') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :class="(modifyPending || positionDetails)?'d-flex':'fullWidh w-100 text-center mt-3'">
                                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-if="modifyPending || positionDetails">{{$t('modify') }}   {{positionDetails?'Trade':'Pending'}} </a>
                                    <a href="javascript:void(0)" class="btn appButton redBG mx-auto justify-content-center" @click.prevent="placeOrder()" v-else> {{$t('btn_place_sell_order')}} </a>
                                    <a href="javascript:void(0)" class="btn appButton mx-auto justify-content-center" @click.prevent="closeOrderWindow()" v-if="modifyPending || positionDetails">{{$t('close') }}  </a>
                                </div>
                            </form>
                        </div>                        
                    </div>
                </div>
            </div>
            <div class="buySell-popup text-center pt-1" v-else-if="tempOrderId != '' && orderPlacedWait && !isTempIdInWS">
                <div class="ppSuccess-icon text-center mt-3 mb-2">
                    <feather size="28px" type="clock"></feather>
                </div>
                <h2>{{$t('placed_order_pending_wait') }} </h2>
                <div class="fullWidh w-100 text-center mt-3">
                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click="clear()">{{$t('place_other_order') }} </a>
                </div>
                <!-- <div class="fullWidh w-100 text-center mt-3">
					<a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click="clear()">Place new Order</a>
				</div> -->
            </div>
            <div class="buySell-popup text-center pt-1" v-else-if="isTempIdInWS">
                <!-- <div class="topPrice mb-3">
                    <p> Price <span class="green vt">{{price || marketPrice}}</span></p>
                    <p> Order: <span :class="(buySellType == 'buy')?'green':'red'">{{buySellType}}</span></p>
                </div> -->
                <div class="ppSuccess-icon text-center mt-1 mb-2">
                    <div class="checkmarkAnimated" v-if="(wsOrder[Array.isArray(tempOrderId)?tempOrderId[0]:tempOrderId] || {}).stat == 'OK'">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 161.2 161.2" enable-background="new 0 0 161.2 161.2" xml:space="preserve">
                        <path class="path" fill="none" stroke="var(--green-color)" stroke-miterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4
                            c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5
                            c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z"/>
                        <circle class="path" fill="none" stroke="var(--green-color)" stroke-width="4" stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1"/>
                        <polyline class="path" fill="none" stroke="var(--green-color)" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="113,52.8 
                            74.1,108.4 48.2,86.4 "/>

                        <circle class="spin" fill="none" stroke="var(--green-color)" stroke-width="4" stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6" r="73.9"/>

                        </svg>
                    </div>
                    <feather size="28px" type="alert-triangle" v-else></feather>
                </div>
                <h2 class="d-flex align-items-center justify-content-center mb-2 ">
                    {{orderPending.symbol}} <span :class="((newBuySellType || buySellType) == 'buy')?'greenBG ml-1':'redBG ml-1'">{{ newBuySellType || buySellType }}</span>
                </h2>
                <template v-if="Array.isArray(tempOrderId)">
                    <h2 v-for="item in tempOrderId" :class="((wsOrder[item] || {}).stat == 'OK')?'green':'red'"
                        v-html="sl_canceled == item?sl_text:tp_canceled == item?tp_text:(wsOrder[item] || {}).resp_msg"
                    ></h2>
                </template>
                <h2 :class="(wsOrder[tempOrderId].stat == 'OK')?'green':'red'" v-html="wsOrder[tempOrderId].resp_msg" v-else></h2>
                <div class="btscure d-flex flex-wrap priceTypeOrder mt-3">
                    <p>{{$t('price') }}:  <span class="green vt">{{price || marketPrice}}</span></p>
                    <p>{{$t('order') }}: <span :class="((newBuySellType || buySellType) == 'buy')?'green':'red'">{{newBuySellType || buySellType}}</span></p>
                    <p>{{$t('type') }}: <span>{{typeList[lastBuyType || buyType]}}</span></p>
                    <p v-if="this.userSettings.position_size && this.userSettings.position_size == '1'">{{$t('units') }}:
                        <span>{{Math.round((newQuantity || quantity) * contractSize * 100) / 100}}</span>
                    </p>
                    <p v-else>{{$t('lot') }}: <span>{{newQuantity || quantity}}</span></p>
                    <p v-if="newTrail || trail">{{$t('trail') }}: <span>{{ newTrail || trail || '0'}}</span></p>
                    <p v-else>{{$t('sl') }}: <span>{{ newStop || stop || '0'}}</span></p>
                    <!-- <p> Trail:          <span>{{trail || '0'}}</span></p> -->
                    <p>{{$t('tp') }}: <span>{{newLimit || limit || '0'}}</span></p>
                </div>
                <div class="fullWidh w-100 text-center mt-3">
                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click="clear()">Place new Order</a>
                </div>
            </div>
            <div v-else>
                <!-- {{tempOrderId}}-{{orderPlacedWait}}-{{wsOrder.hasOwnProperty(tempOrderId)}} -->
            </div>
        </div>
        <div class="showModal custom-modal" v-else>
            <div class="buySell-popup text-center">
                <div class="ppSuccess-icon text-center mt-3 mb-2">
                    <feather size="28px" type="alert-triangle"></feather>
                </div>
                <h2>{{$t('no_account_id_found') }} </h2>
                <!-- <div class="fullWidh w-100 text-center mt-3">
                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click="clear()">Place Other Order</a>
                </div> -->
                <!-- <div class="fullWidh w-100 text-center mt-3">
                    <a href="javascript:void(0)" class="btn appButton greenBG mx-auto justify-content-center" @click="clear()">Place new Order</a>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { Const } from '@/plugins/vue-provider-cache/const.mod'
import { commonAllmixins } from '@/plugins/commonAll'
import { Validator } from 'vee-validate';
const paramNames = ['val'];
const lessThen = (value, [val] = {}) => { 
    // console.log(value, 'here is the less than values...')
    return Number(val) > value;
};
Validator.extend('lessThen', lessThen, { paramNames });
const divisibleByCheck = (value, val) => { 
    const tolerance = 1e-10; // Tolerance for floating-point comparison
    if (!val) return false; // Prevent division by undefined or zero
    const quotient = value / val;
    return Math.abs(quotient - Math.round(quotient)) < tolerance;
};
const divisibleBy = (value, [val] = {}) => { 
    const tolerance = 1e-10; // Tolerance for floating-point comparison
    const quotient = value / val;
    // return Math.abs((value / val) % 1) < tolerance;
    return Math.abs(quotient - Math.round(quotient)) < tolerance;
};
Validator.extend('divisibleBy', divisibleBy, { paramNames });

const greaterThen = (value, [val] ) => { return Number(val) < Number(value); };
Validator.extend('greaterThen', greaterThen, { paramNames });
let successTimeout, confirmationMessage;
const product_type = process.env.product_type;
const product = process.env.product;
export default {
    name: 'Buy-Sell-right-tab',
     // props:['buySellType'],
    mixins: [commonAllmixins],
    data() {
        return {
			buyType: 'M',
			step: '1',
			orderPending: {},
			tempOrderId: '',
			orderPlacedWait: false,
			submitted: false,
			advance:false,
			quantity: '',
			units: '',
			buySellType: 'buy',
			price: '',
            marketPrice: '',
			stop: '',
			stop_pip: '',
			stop_pnl: '',
            stopPlaceHolder: '',
			edit_stop: false,
			trail: '',
			edit_trail: false,
			limit: '',
			limit_pip: '',
			limit_pnl: '',
            limitPlaceHolder: '',
			edit_limit: false,
			comment: '',
			newQuantity: '',
			newStop: '',
			newTrail: '',
			newLimit: '',
			lastBuyType: '',
			newBuySellType: '',

            isPriceActive: false, // if SL and TP input field is active then set true
            prev_Bid : 0,
            pnl_focus : false,

            plotted:[],
            tempReg: [],
            sl_canceled : '',
            sl_text : 'Stop loss has been removed.',
            tp_canceled : '',
            tp_text : 'Take Profit has been removed.',
            typeList:{
                'M':"Market",
                'S':"Entry Stop",
                'L':"Entry Limit"
            },
            tfc: true,
            modifyPending: null,
            positionDetails :null,
            sideValue:{
                '0':'Sell',
                '1':'Buy',
            },
            sideClass:{
                '0':'red',
                '1':'green',
            },
            pip_difference : 2,
            delay_lot: false,
            position_size_old: ''

        }
    },
    props:['currency_pair','modifyTradeDetail','modifyOrderDetail', 'placetradeDetail'],
    emits:['clearTrade'],
    watch:{
        currency_pair(val){
            if (this.instruments && this.instruments[val] && this.accountList && this.accountList.Currency) {
                this.convertCurrencyUnified(this.accountList.Currency, this.instruments[val], this.instruments, product, product_type);
            }

            if(this.userSettings.lotsize && this.userSettings.lotsize >= this.instruments[val].other.Min_Trade_Size){
                this.quantity = this.userSettings.lotsize;
                this.lot = this.userSettings.lotsize;
            }else{
                this.quantity = this.instruments[val].other.Min_Trade_Size;
                this.lot = this.instruments[val].other.Min_Trade_Size;
            }
            this.changeBuySell('buy');this.contractSize
            setTimeout(() => {
                window['myStxx'].tfc.clearOpenTrades()
            }, 1200);
        },
        units(val){
            const rounded = Math.round(val * 100) / 100;
            if (val !== rounded) { this.units = rounded; return; }
            const qty = rounded / this.contractSize;
            const minTradeSize = this.getMinMaxQuantity(0);
            if (this.quantity !== qty && divisibleByCheck(qty, minTradeSize)) {
                this.quantity = Math.round(qty * 100) / 100;
            }
        },
        quantity(val){
            // const rounded = Math.round(val * 100) / 100; if (val !== rounded ) { this.quantity = rounded; return; }
            let upper = 3, lower = 3;
            try{ upper = this.instruments[this.currency_pair].other.Max_Trade_Size.length}catch(e){}
            try{ lower = this.instruments[this.currency_pair].other.Min_Trade_Size.split('.')[1].length}catch(e){}
            if(this.units != val * this.contractSize){
                this.units = val * this.contractSize;
            }
            if(this.edit_stop && this.stop){
                this.calculateStopPip();
            }
            if(this.edit_limit && this.limit){
                this.calculateLimitPip();
            }
            // CIQ.setValueIfNotActive(null, amount.toFixed(0));
            // if(window['myStxx'] && window['myStxx'].tfc && window['myStxx'].tfc._isOpen && this.tfc && val && window['myStxx'].tfc.activeTrade){
                // let quantity = document.querySelector(".stx-data .tfc-shares.stx-input-field")
                // console.log(quantity, CIQ.commas(val))
                // window['myStxx'].tfc.changeQuantity()
                // CIQ.setValueIfNotActive(quantity, CIQ.commas(val));
            // }
            // console.log(quantity)
            // console.log(quantity.value)
            // this.quantity = val.toString()
            //     .replace(/[^\d.]/g, '')             // numbers and decimals only
            //     .replace(this.getUpper(upper), '$1')   // not more than 2 digits at the beginning
            //     .replace(/(\..*)\./g, '$1')         // decimal can't exist more than once
            //     .replace(this.getLower(lower), '$1');    // not more than 4 digits after decimal
        },
        price(val){
            this.changeValidation('price',val)
            if(window['myStxx'].tfc && window['myStxx'].tfc._isOpen && this.tfc && val){
                if(window['myStxx'].tfc.activeTrade){
                    window['myStxx'].tfc.positionCenterLine(Number(val));
                    // console.log('------------4--------------')
                }else if(!this.positionDetails){
                    let windowType = this.buySellType == 'buy'?'enableBuy':'enableSell';
                    window['myStxx'].tfc.newTrade(windowType,Number(val));
                }
            }
            if(this.edit_stop && this.stop){
                this.calculateStopPip();
            }
            if(this.edit_limit && this.limit){
                this.calculateLimitPip();
            }
        },
        stop_pnl(val){
            this.updateTfcPnlLabels();
        },
        limit_pnl(val){
            this.updateTfcPnlLabels();
        },
        
        userSettings(val){
            if(this.userSettings.lotsize){
                if(this.userSettings.position_size && this.position_size_old != this.userSettings.position_size){
                    this.delay_lot = true
                }
                this.position_size_old = this.userSettings.position_size
                this.quantity = this.userSettings.lotsize
                this.lot = this.userSettings.lotsize
            }
            let _that = this;
            setTimeout(()=>{ _that.delay_lot = false; }, 200)
        },
        modifyTradeDetail(val){
            if(val){
                this.clear();
                this.tempOrderId = '';
                this.orderPlacedWait = false;
                this.changeBuySell(val.Side?'buy':'sell');
                if(window['myStxx'] && window['myStxx'].tfc){
                    window['myStxx'].tfc.closeTFC()
                }
                this.positionDetailsUpdate(val)
            }else if(this.positionDetails){
                this.closeOrderWindow();
            }
                
        },
        async modifyOrderDetail(val){
            if(val){
                this.clear();
                this.changeBuySell(val.Side?'buy':'sell');
                if(window['myStxx'] && window['myStxx'].tfc){
                    window['myStxx'].tfc.closeTFC()
                }
                this.tempOrderId = ''
                this.orderPlacedWait = false;
                await new Promise(resolve => setTimeout(resolve, 500));
                this.pendingOrderUpdate(val)
            }else if(this.modifyPending){
                this.closeOrderWindow();
            }
        },
        placetradeDetail(val){
            this.$emit
            this.buyType=val.orderType
            this.buySellType = val.buySellType
            this.price = val.price;
            this.quantity = 0.1
            this.advance = false
            this.stop = ''
            this.stop_pip = ''
            this.trail = ''
            this.limit = ''
            this.comment = ''
            this.openBuySellWindowFromChart(val.price)
        },
        B(){
            if(!this.pnl_focus && (this.buyType == 'M' || this.modifyTradeDetail) && !this.isPriceActive && this.prev_Bid != this.B){
                this.prev_Bid = this.B;
                if(this.edit_stop && this.stop){
                    // this.change_stop_pip();
                    this.calculateStopPip();
                }
                if(this.edit_limit && this.limit){
                    // this.change_limit_pip();
                    this.calculateLimitPip();
                }
            }
        }
    },
    methods:{
        updateTfcPnlLabels() {
            if (!window['myStxx'] || !window['myStxx'].tfc || !window['myStxx'].tfc.elements) return;
            let tfc = window['myStxx'].tfc;
    
            const formatPnlDisplay = (val) => {
                if (!val) return '';
                const strVal = String(val);
                const match = strVal.match(/[\d,]+(\.\d+)?/);
                if (!match) return strVal;
                const numStr = match[0].replace(/,/g, '');
                const parts = numStr.split('.');
                let formattedNum = parts[0];
                if (parts.length > 1) {
                    const combined = parseFloat(`${parts[0]}.${parts[1].substring(0, 2)}`);
                    formattedNum = combined.toString();
                }
                let result = strVal.replace(match[0], formattedNum);
                if (formattedNum === '0') {
                    result = result.replace('-', '');
                }
                return result;
            };

            const formatCurrencyDirect = (val, currency) => {
                const sign = val > 0 ? "+" : (val < 0 ? "-" : "");
                // If there's an existing CIQ.money formatter we can use it, or fallback.
                if (window.CIQ && window.CIQ.money) {
                    return sign + window.CIQ.money(Math.abs(val), null, window.CIQ.convertCurrencyCode(currency));
                }
                return sign + Number(Math.abs(val)).toFixed(2) + " " + (currency || "");
            };

            let getSpPnl = Number(this.stop_pnl || 0);
            let getTpPnl = Number(this.limit_pnl || 0);
            let baseCurrency = this.accountList ? this.accountList.Currency : '';
            let selectedTab = this.buySellType; // 'buy' or 'sell'
            let selectedSubTab = this.buyType; // 'M', 'L', 'S', etc.
            let modifyType = this.modifyTradeDetail ? (this.modifyTradeDetail.Side == 1?'buy':'sell') : (this.modifyPending?this.modifyPending.Type:null);

            if (selectedTab === 'buy') {
                if (tfc.elements.aboveGainPercent) {
                    tfc.elements.aboveGainPercent.innerHTML = formatPnlDisplay(formatCurrencyDirect(getTpPnl, baseCurrency));
                }
                if (tfc.elements.belowGainPercent) {
                    tfc.elements.belowGainPercent.innerHTML = formatPnlDisplay(formatCurrencyDirect(getSpPnl, baseCurrency));
                }
            } else {
                // sell
                if (tfc.elements.aboveGainPercent) {
                    tfc.elements.aboveGainPercent.innerHTML = formatPnlDisplay(formatCurrencyDirect(getSpPnl, baseCurrency));
                }
                if (tfc.elements.belowGainPercent) {
                    tfc.elements.belowGainPercent.innerHTML = formatPnlDisplay(formatCurrencyDirect(getTpPnl, baseCurrency));
                }
            }

            if (tfc.elements.gainPercent) {
                if (selectedSubTab === 'S' || selectedSubTab === 'ES' || modifyType === 'S' || modifyType === 'ES') {
                    tfc.elements.gainPercent.innerHTML = formatPnlDisplay(formatCurrencyDirect(getSpPnl, baseCurrency)) || formatPnlDisplay(formatCurrencyDirect(getTpPnl, baseCurrency));
                } else if (selectedSubTab === 'L' || selectedSubTab === 'EL' || modifyType === 'L' || modifyType === 'EL') {
                    tfc.elements.gainPercent.innerHTML = formatPnlDisplay(formatCurrencyDirect(getTpPnl, baseCurrency)) || formatPnlDisplay(formatCurrencyDirect(getSpPnl, baseCurrency));
                } else {
                    tfc.elements.gainPercent.innerHTML = formatPnlDisplay(formatCurrencyDirect(getSpPnl, baseCurrency)) || formatPnlDisplay(formatCurrencyDirect(getTpPnl, baseCurrency));
                }
            }
        },
        closeOrderWindow(){
            if(window['myStxx'] && window['myStxx'].tfc){
                window['myStxx'].tfc.closeTFC()
            }
            this.modifyPending = null;
            this.positionDetails = null;
            this.changeBuySell('buy');
            if(this.modifyTradeDetail || this.modifyOrderDetail){
                this.$emit('clearTrade')
            }
        },
        cancelOrder(item,type){
            const tempOrderId = new Date().getTime()
            if(type == 'SL'){
                this.sl_canceled = tempOrderId;
            }else if(type == 'TP'){
                this.tp_canceled = tempOrderId;
            }
            let orderJson = {
				"order_id" : item.OrderID,
				"tempOrderId" : tempOrderId,
				'localParams':this
			}
            this.tempOrderId.push(tempOrderId)
            this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].cancelOrder(orderJson)

            if(window['myStxx'] && window['myStxx'].tfc){
                window['myStxx'].tfc.closeTFC()
            }
            this.modifyPending = null;
            this.positionDetails = null;
            this.changeBuySell('buy');
            if(this.modifyTradeDetail){
                this.$emit('clearTrade')
            }
        },
        openMarketLine(){
            if(this.advance && !this.modifyPending && !this.positionDetails){
                if(window['myStxx'] && window['myStxx'].tfc && window['myStxx'].tfc._isOpen && this.tfc){
                    if(!window['myStxx'].tfc.activeTrade){
                        window['myStxx'].tfc.newTrade('enableEditTrade', { Side :  (this.buySellType == 'buy'?1:0) })
                        window['myStxx'].tfc.positionCenterLine(this.B);
                        // console.log('------------3--------------')
                    }
                }/*else if(this.tfc){
                    this.openTfcPanel()
                }*/
            }
        },
        openTfcPanel(){
            document.querySelector("cq-toggle.sidebar.stx-trade").click();
            if(this.buyType == 'M'){
                this.openMarketLine();
            }else{
                this.openBuySellWindow();
            }
        },
        positionDetailsUpdate(val){
            if(val){
                this.positionDetails = val;
                
                this.price = this.positionDetails.Price
                let lotBy = 100000;
                this.symbol = this.positionDetails.Symbol;
                this.currency_pair = this.positionDetails.Symbol;
                this.comment = this.positionDetails.Commentary;
                // if(this.positionDetails.Trail.Trail || this.positionDetails.SL.Price || this.positionDetails.TP.Price){
                    this.advance = true;
                // }
                this.trail = this.positionDetails.Trail.Trail || '';
                if(this.trail){
                    this.edit_trail = true;
                }else{
                    this.stop = this.positionDetails.SL.Price || '';
                    if(this.stop){
                        this.edit_stop = true;
                    }else{
                        this.edit_stop = false;
                    }
                    this.edit_trail = false;
                }
                this.limit = this.positionDetails.TP.Price || '';
                if(this.limit){
                    this.edit_limit = true;
                }else{
                    this.edit_limit = false;
                }
                try{
                    lotBy = this.currencyPairs.find(v=>v.mn == val.Symbol).market_ContractSize || 100000
                }catch(e){}
                // this.lot = this.positionDetails.Quantity?(this.positionDetails.Quantity / lotBy):0
                this.quantity = this.positionDetails.Quantity?(this.positionDetails.Quantity / lotBy):0
                const _that=this
                setTimeout(()=>{
                    if(window['myStxx'] && window['myStxx'].tfc){
                        if(!window['myStxx'].tfc._isOpen){
                            document.querySelector("cq-toggle.sidebar.stx-trade").click();
                        }
                        // console.log('enableEditTrade', _that.positionDetails)
                        window['myStxx'].tfc.newTrade('enableEditTrade', _that.positionDetails)
                        window['myStxx'].tfc.positionCenterLine(_that.price);
                        // console.log('------------2--------------')

                        if(_that.advance){
                            if(!this.edit_trail) _that.positionDetails.SL.Price?window['myStxx'].tfc.addOTOStop(_that.positionDetails.SL.Price):'';
                            _that.positionDetails.TP.Price?window['myStxx'].tfc.addOTOLimit(_that.positionDetails.TP.Price):'';
                        }
                        
                    }
                },1000)
            }else{
                this.positionDetails = null
            }
        },
        pendingOrderUpdate(val){
            if(val){
                let lotBy = 100000;
                try{
                    lotBy = this.currencyPairs.find(v=>v.mn == val.Symbol).market_ContractSize || 100000
                }catch(e){}
                let quantity = val.Quantity?(val.Quantity / lotBy):0
                let action = val.Side?"buy":"short";
                let openOrder = {
                    "id": val.OrderID,
                    "tradeid": val.AccountID,
                    action,
                    "quantity": quantity,
                    "tif": ""
                }
                if(action == 'buy'){
                    if(val.Type == 'ES'){
                        openOrder['stop'] = Number(val.Price)
                    }else if(val.Type == 'EL'){
                        openOrder['limit'] = Number(val.Price)
                    }
                }else if(action == 'short'){
                    if(val.Type == 'ES'){
                        openOrder['limit'] = Number(val.Price);
                    }else if(val.Type == 'EL'){
                        openOrder['stop'] = Number(val.Price)
                    }
                }
                this.price = Number(val.Price)
                this.advance = true;
                this.buyType = '';
                this.buySellType = val.Side == 1?'buy':'sell';
                if(this.buySellType == 'sell'){
                    if(this.B > this.price && this.buyType != 'S'){
                        this.buyType = 'S';
                    }else if(this.B < this.price && this.buyType != 'L'){
                        this.buyType = 'L';
                    }
                }else if(this.buySellType == 'buy'){
                    if(this.B > this.price && this.buyType != 'L'){
                        this.buyType = 'L';
                    }else if(this.B < this.price && this.buyType != 'S'){
                        this.buyType = 'S';
                    }
                }
                // let windowType = action == 'buy'?'enableBuy':'enableShort';
                if(window['myStxx'] && window['myStxx'].tfc){
                    // window['myStxx'].tfc.newTrade(windowType,{ openOrder: openOrder });
                    window['myStxx'].tfc.modifyOpenOrderSelf(openOrder)
                }
            }
        },
        change_stop(val){
            if(!val){ return; }
            this.calculateStopPip()
            // this.changeValidation('stop',val)
            if(window['myStxx'].tfc && window['myStxx'].tfc._isOpen && this.tfc){
                window['myStxx'].tfc.addOTOStop(Number(val))
            }
        },
        trail(val){
            this.trail = val.toString()
                .replace(/[^\d]/g, '')              // numbers only
                .replace(/(^[\d]{20})[\d]/g, '$1')  // not more than 2 digits at the beginning/(^[\d]{6})[\d]/g
        },
        change_limit(val){
            if(!val){ return; }
            this.calculateLimitPip()
            // this.changeValidation('limit',val)
            if(window['myStxx'].tfc && window['myStxx'].tfc._isOpen && this.tfc){
                window['myStxx'].tfc.addOTOLimit(Number(val))
            }
        },
    	advance(val){
    		this.edit_stop = false
    		this.edit_trail = false
    		this.edit_limit = false
    	},
        /*getProfitLoss(type, symbolData) {
            try {
                if (!symbolData) return "0";
                let lotBy = 100000;
                try{
                    lotBy = this.currencyPairs.find(v=>v.mn == this.currency_pair).market_ContractSize || 100000;
                }catch(e){}
                const quantity = this.quantity*lotBy;
                const price = type === 'S' ? this.stop : this.limit;
                const askPrice = this.price || this.A;
                const bidPrice = this.price || this.B;
                let BSprice;
                if(this.buySellType == 'buy'){
                    BSprice = type === 'L' ? price - bidPrice: price - askPrice;
                }else{
                    BSprice = type === 'L' ? bidPrice - price : askPrice - price;
                }
                // console.log(this.convertCurrency(symbolData, this.instruments))
                return parseFloat( BSprice * quantity * parseFloat(this.convertCurrency(symbolData, this.instruments)) );
            } catch (e){
                return 0;
            }
        },*/
        getProfitLoss(type, symbolData) {
            try {
                if (!symbolData) return "0";
                let lotBy = 100000;
                try{
                    lotBy = this.currencyPairs.find(v=>v.mn == this.currency_pair).market_ContractSize || 100000;
                }catch(e){}
                const quantity = this.quantity * lotBy;
                const price = type === 'S' ? this.stop : this.limit;
                const marketPrice = this.price || (this.buySellType == 'buy' ? this.A : this.B);

                const BSprice = this.buySellType === 'buy' ? price - marketPrice : marketPrice - price;

                let conversionRate = parseFloat(this.convertCurrency(symbolData, this.instruments));
                if (conversionRate === 1) {
                    const accountCurrency = this.accountList.Currency;
                    conversionRate = parseFloat(this.convertCurrencyUnified(accountCurrency, symbolData, this.instruments, product, product_type)) || 1;
                }

                return parseFloat( BSprice * quantity * conversionRate );
            } catch (e) {
                return 0;
            }
        },
        convertCurrency(symbol, isins) {
            const accountCurrency = this.accountList.Currency
            symbol.other.base_currency = symbol.other.base_currency.split('_V')[0];
            const base = symbol.other.base_currency;
            const acc = accountCurrency //.toUpperCase();
            const product = product_type; // assuming it's globally accessible

            if (acc === base) return 1;

            const getPossibleKeys = (cur1, cur2) => [
                `${cur1}/${cur2}${product_type}`,
                `${cur1}${cur2}.`,
                `${cur1}${cur2}_`,
                `${cur1}${cur2}${product_type}`
            ];

            const tryGetRateFromPairs = (cur1, cur2, invert = false) => {
                if(cur1 == cur2) return 1;
                const keys = getPossibleKeys(cur1, cur2);
                if ((cur1 === 'BTC' && cur2 === 'USD') || (cur1 === 'USD' && cur2 === 'BTC')) keys.push('Bitcoin');
                for (const key of keys) {
                    const item = isins[key];
                    if (item && item.A) return invert ? 1 / item.A : item.A;
                }
                return null;
            };

            // 1. Try direct and inverse rates
            let rate = tryGetRateFromPairs(acc, base, true) || tryGetRateFromPairs(base, acc, false);
            if (rate) return rate;

            // 2. Use USD as intermediary
            const toUSD = tryGetRateFromPairs(base, 'USD' + product) || tryGetRateFromPairs('USD', base + product, true);
            const fromUSD = 
                tryGetRateFromPairs(acc, 'USD' + product, true) ||
                tryGetRateFromPairs('USD', acc + product) ||
                tryGetRateFromPairs(acc, product);

            if (fromUSD && toUSD) return ((toUSD == 1) ? toUSD/fromUSD : fromUSD * toUSD);

            // 3. Fallback using symbol directly
            const fallbackKey = acc + product;
            if (isins[fallbackKey]) {
                return Number(symbol.A || 1) / Number(isins[fallbackKey].A || 1);
            }

            return 1; // final fallback
        },
        subscribeIsisn(isin){
            isin = isin.replace('/','')
            if(this.tempReg.includes(isin)){
                return;
            }else{
                this.tempReg.push(isin);
                this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].subscribeSaveToWatchlistZero([isin])
            }
        },
        convertCurrencyUnified(accountCurrency, symbol, isins, product, product_type) {
            // 1. Prepare Base Currency safely without mutating the original object
            let baseCurr = symbol.other.base_currency;
            if (baseCurr.includes('_V')) {
                baseCurr = baseCurr.split('_V')[0];
            }
            
            const accCurr = accountCurrency.toUpperCase();
            const isHanko = product === 'Hanko';

            // To cleanly mimic backward compatibility:
            const directSuffix = isHanko ? (product_type || "") : "";
            const usdSuffix = product_type || ""; 

            // 2. Direct Match
            if (accCurr === baseCurr.toUpperCase()) {
                return 1;
            }

            let isGet = false;
            let rate = 0;

            // 3. Check Direct Pairs (e.g., EURJPY)
            const pairDirect = accCurr + baseCurr + directSuffix;
            const pairInverted = baseCurr + accCurr + directSuffix;

            if (isins[pairDirect] && isins[pairDirect].A) {
                rate = 1 / isins[pairDirect].A;
                isGet = true;
            } else if (isins[pairInverted] && isins[pairInverted].A) {
                rate = isins[pairInverted].A;
                isGet = true;
            }

            // 4. Triangulation via USD
            if (!isGet) {
                let baseToUSD = 0;
                let accToUSD = 0;

                // Base to USD
                if (isins[baseCurr + "USD" + usdSuffix]) {
                    baseToUSD = isins[baseCurr + "USD" + usdSuffix].A;
                } else if (isins["USD" + baseCurr + usdSuffix]) {
                    baseToUSD = 1 / isins["USD" + baseCurr + usdSuffix].A;
                }

                // Account to USD
                if (isins[accCurr + "USD" + usdSuffix]) {
                    accToUSD = 1 / isins[accCurr + "USD" + usdSuffix].A;
                } else if (isins["USD" + accCurr + usdSuffix]) {
                    accToUSD = isins["USD" + accCurr + usdSuffix].A;
                }

                if (baseToUSD && accToUSD) {
                    rate = accToUSD * baseToUSD;
                    isGet = true;
                }
            }

            // 5. Final Fallback (from 'new_old' logic)
            if (!isGet && isins[accCurr + usdSuffix]) {
                rate = Number(symbol.A || 1) / Number(isins[accCurr + usdSuffix].A || 1);
                isGet = true;
            }

            // 6. Auto-Subscribe to combinations if still missing locally
            if (!isGet) {
                this.subscribeIsisn(pairDirect);
                this.subscribeIsisn(pairInverted);
                this.subscribeIsisn(baseCurr + "USD" + usdSuffix);
                this.subscribeIsisn("USD" + baseCurr + usdSuffix);
                this.subscribeIsisn(accCurr + "USD" + usdSuffix);
                this.subscribeIsisn("USD" + accCurr + usdSuffix);
            }

            return rate || 1;
        },
        convertCurrency_old( symbol, isins){
            const accountCurrency = this.accountList.Currency
            // const baseCurrency = symbol.other.base_currency;
            symbol.other.base_currency = symbol.other.base_currency

            if(accountCurrency==symbol.other.base_currency){
                return 1
            }else{
                let isGet = false
                const firstCurrency = accountCurrency.toUpperCase()+symbol.other.base_currency+product_type

                // console.log("firstCurrency", firstCurrency);
                let buy_sell = this.buySellType == 'buy' ? 'A' : 'B';
                if(isins[firstCurrency]){
                    return 1/isins[firstCurrency][buy_sell];
                    isGet = true
                }

                const firstCurrencyWithSlash = accountCurrency.toUpperCase()+symbol.other.base_currency+product_type

                if(isins[firstCurrencyWithSlash]){
                    return 1/isins[firstCurrencyWithSlash][buy_sell];
                    isGet = true;
                }

                const secondCurrency = symbol.other.base_currency+accountCurrency.toUpperCase()+product_type

                

                if(isins[secondCurrency]){
                    return isins[secondCurrency][buy_sell];
                    isGet = true;
                }
                const secondCurrencyWithSlash = symbol.other.base_currency+accountCurrency.toUpperCase()+product_type

                if(isins[secondCurrencyWithSlash]){
                    return isins[secondCurrencyWithSlash][buy_sell];
                    isGet = true;
                }
                
                //===============================if not found
                let secontoUSD = 0
                let accBasetoUSD = 0
                if(isins[symbol.other.base_currency+"USD"+product_type]   ){
                    secontoUSD = isins[symbol.other.base_currency+"USD"+product_type][buy_sell]
                    isGet = true;
                } 
                else if(isins['USD'+symbol.other.base_currency+product_type]){
                    secontoUSD = 1/isins['USD'+symbol.other.base_currency+product_type][buy_sell]
                    isGet = true;
                } 
                
                if(isins[accountCurrency.toUpperCase()+'USD'+product_type]){
                    accBasetoUSD = 1/isins[accountCurrency.toUpperCase()+'USD'+product_type][buy_sell]
                    isGet = true;
                } 
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type][buy_sell]
                    isGet = true;
                }
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type][buy_sell]
                    isGet = true;
                }
                // if(!isGet){
                //     this.subscribeIsisn(firstCurrency)
                //     this.subscribeIsisn(firstCurrencyWithSlash)
                //     this.subscribeIsisn(secondCurrency)
                //     this.subscribeIsisn(secondCurrencyWithSlash)
                //     this.subscribeIsisn(symbol.other.base_currency+"USD"+product_type)
                //     this.subscribeIsisn('USD'+symbol.other.base_currency+product_type)
                //     this.subscribeIsisn(accountCurrency.toUpperCase()+'USD'+product_type)
                //     this.subscribeIsisn('USD'+accountCurrency.toUpperCase()+product_type)
                // }
                return accBasetoUSD * secontoUSD
            }
        },
        convertCurrency_old(symbol, isins) {
            // console.log(symbol)
            const accountCurrency = this.accountList.Currency
            const baseCurrency = symbol.other.base_currency;

            // 1. Direct match with account currency
            if (accountCurrency === baseCurrency) {
                return 1;
            }

            // Helper function to retrieve rate
            let buy_sel = this.buySellType == 'buy' ? 'A' : 'B'
            const getRate = (currencyPair) => (isins[currencyPair] || {})[buy_sel] || 0;

            // 2. Check direct conversion rates
            const directPairs = [
                `${accountCurrency.toUpperCase()}${baseCurrency}${product_type}`,
                `${accountCurrency.toUpperCase()}/${baseCurrency}${product_type}`,
                `${baseCurrency}${accountCurrency.toUpperCase()}${product_type}`,
                `${baseCurrency}/${accountCurrency.toUpperCase()}${product_type}`,
            ];

            for (const pair of directPairs) {
                const rate = getRate(pair);
                if (rate) {
                    return pair.includes('/') ? 1 / rate : rate;
                }
            }

            // 3. Conversion through USD
            const usdPairs = {
                baseToUSD: `${baseCurrency}USD${product_type}`,
                usdToBase: `USD${baseCurrency}${product_type}`,
                accountToUSD: `${accountCurrency.toUpperCase()}USD${product_type}`,
                usdToAccount: `USD${accountCurrency.toUpperCase()}${product_type}`,
            };

            const secontoUSD = getRate(usdPairs.baseToUSD) || (1 / getRate(usdPairs.usdToBase));
            const accBasetoUSD = (1 / getRate(usdPairs.accountToUSD)) || getRate(usdPairs.usdToAccount);

            // 4. Return calculated conversion rate
            return accBasetoUSD && secontoUSD ? accBasetoUSD * secontoUSD : 0;
        },
        getPriceFromPnl(type, pnl, symbolData) {
            if (!symbolData) return 0;

            try {
                const lotBy = this.currencyPairs.find(v => v.mn === this.currency_pair).market_ContractSize || 100000;
                const quantity = this.quantity * lotBy;
                
                let conversionRate = parseFloat(this.convertCurrency(symbolData, this.instruments));
                if (conversionRate === 1) {
                    const accountCurrency = this.accountList.Currency;
                    conversionRate = parseFloat(this.convertCurrencyUnified(accountCurrency, symbolData, this.instruments, product, product_type)) || 1;
                }

                const marketPrice = parseFloat(this.price || (this.buySellType == 'buy' ? this.A : this.B));
                const adjustment = pnl / (quantity * conversionRate);
                return this.buySellType === 'buy'? (marketPrice + adjustment) : (marketPrice - adjustment);
            } catch (e) {
                return 0;
            }
        },
        calculate_stop_pnl() {
            this.stop_pnl = parseFloat(this.getProfitLoss('S', this.instruments[this.currency_pair])).toFixed(2);
        },
        change_stop_pnl(){
            if(this.stop_pnl){
                this.isPriceActive = true;
                let price = this.getPriceFromPnl('S', this.stop_pnl, this.instruments[this.currency_pair])
                this.stop = price.toFixed(this.precision_val || this.contractSize.length-1);
                
                this.change_stop(this.stop);
                this.calculateStopPip();
                this.isPriceActive = false;
            }
        },
        calculateStopPip(){
            if(!this.isPriceActive) this.calculate_stop_pnl();
            if (this.$refs['stop pipInput'] != document.activeElement) {
                let price = 0;
                if(this.price && !this.modifyTradeDetail){
                    price = Number(this.price - this.SPREAD)
                }else{
                    price = Number(this.buySellType == 'buy' ? this.B : this.A);
                }
                if(this.buySellType == 'buy'){
                    this.stop_pip = Number((price - this.stop)/this.pipSize).toFixed(1);
                }else{
                    this.stop_pip = Number((this.stop - price)/this.pipSize).toFixed(1);
                }
            }
        },
    	change_stop_pip(){
            if(this.stop_pip){
                this.isPriceActive = true;
                let val = 0;
                if(this.price && !this.modifyTradeDetail){
                    val = Number(this.price - this.SPREAD)
                }else{
                    val = Number(this.buySellType == 'buy' ? this.B : this.A);
                }
                if(this.buySellType == 'buy'){
                    val -= (this.pipSize*this.stop_pip);
                }else{
                    val += (this.pipSize*this.stop_pip);
                }
                this.stop = val.toFixed(this.precision_val);
                this.change_stop(this.stop)
                this.calculate_stop_pnl()
                this.isPriceActive = false;
            }
        },
    	change_edit_stop(){
            const val=this.edit_stop
            if(!val){
				this.stop = '';
				this.stop_pip = '';
                if(window['myStxx'].tfc && window['myStxx'].tfc._isOpen && this.tfc){
                    if(this.buySellType=='sell') window['myStxx'].tfc.removeOTOAbove(0)
                    if(this.buySellType=='buy') window['myStxx'].tfc.removeOTOBelow(0)
                }/*else if(this.tfc){
                    this.openTfcPanel()
                    this.change_edit_stop()
                }*/
    		}else{
				this.edit_trail = false
                this.stopPlaceHolder = this.instruments[this.currency_pair].A
                let val = 0;
                if(this.price){
                    val = Number(this.price - this.SPREAD)
                }else{
                    val = Number(this.buySellType == 'buy' ? this.B : this.A);
                }
                if(this.buySellType == 'buy'){
                    val -= (this.pipAddition);
                }else{
                    val += (this.pipAddition);
                }
                this.stop = val.toFixed(this.precision_val);
                this.stop_pip = this.pip_difference;
                this.calculateStopPip();
                if(window['myStxx'].tfc && window['myStxx'].tfc._isOpen && this.tfc){
                    window['myStxx'].tfc.addOTOStop(this.stop)
                    // window['myStxx'].tfc.addOTOStop(/*Number(this.price)*/)
                    // if(this.buySellType=='sell') window['myStxx'].tfc.addOTOStop()
                    // if(this.buySellType=='buy') window['myStxx'].tfc.addOTOLimit()
                }/*else if(this.tfc){
                    this.openTfcPanel()
                    this.change_edit_stop()
                }*/
    		}
    	},
    	change_edit_trail(){
    		if(!this.edit_trail){
				this.trail = ''
    		}else{
				this.edit_stop = false
                this.change_edit_stop()
    		}
    	},
        calculate_limit_pnl() {
            // // console.log('-----------',this.getProfitLoss('L', this.instruments[this.currency_pair]))
            this.limit_pnl = parseFloat(this.getProfitLoss('L', this.instruments[this.currency_pair])).toFixed(2);
        },
        change_limit_pnl(){
            if(this.limit_pnl){
                this.isPriceActive = true;
                let price = this.getPriceFromPnl('L', this.limit_pnl, this.instruments[this.currency_pair])
                this.limit = price.toFixed(this.precision_val || this.contractSize.length-1);
                
                this.change_limit(this.limit);
                this.calculateLimitPip();
                this.isPriceActive = false;
            }
        },
        calculateLimitPip(){
            if(!this.isPriceActive) this.calculate_limit_pnl();
            if (this.$refs['limit pipInput'] != document.activeElement) {
                let price = 0;
                if(this.price && !this.modifyTradeDetail){
                    price = Number(this.price - this.SPREAD)
                // }else if (this.modifyTradeDetail){
                //     price = Number(this.buySellType == 'buy' ? this.A : this.B);
                }else{
                    price = Number(this.buySellType == 'buy' ? this.B : this.A);
                }
                if(this.buySellType == 'buy'){
                    this.limit_pip = Number((this.limit - price)/this.pipSize).toFixed(1);
                }else{
                    this.limit_pip = Number((price - this.limit)/this.pipSize).toFixed(1);
                }
            }
        },
        change_limit_pip(){
            if(this.limit_pip){
                this.isPriceActive = true;
                let val = 0;
                if(this.price && !this.modifyTradeDetail){
                    val = Number(this.price - this.SPREAD)
                // }else if (this.modifyTradeDetail){
                //     val = Number(this.buySellType == 'buy' ? this.A : this.B);
                }else{
                    val = Number(this.buySellType == 'buy' ? this.B : this.A);
                }
                if(this.buySellType == 'buy'){
                    val += (this.pipSize*this.limit_pip);
                }else{
                    val -= (this.pipSize*this.limit_pip);
                }
                this.limit = val.toFixed(this.precision_val);
                this.change_limit(this.limit)
                this.calculate_limit_pnl()
                this.isPriceActive = false;
            }
        },
    	change_edit_limit(){
            const val=this.edit_limit
            if(!val){
				this.limit = ''
				this.limit_pip = ''
                if(window['myStxx'].tfc && window['myStxx'].tfc._isOpen && this.tfc){
                    // window['myStxx'].tfc.removeOTOBelow()
                    if(this.buySellType=='buy') window['myStxx'].tfc.removeOTOAbove(0)
                    if(this.buySellType=='sell') window['myStxx'].tfc.removeOTOBelow(0)
                }
    		}else{
                this.limitPlaceHolder = this.instruments[this.currency_pair].A
                let val = 0;
                if(this.price){
                    val = Number(this.price - this.SPREAD)
                }else{
                    val = Number(this.buySellType == 'buy' ? this.B : this.A);
                }
                if(this.buySellType == 'buy'){
                    val += (this.pipAddition);
                }else{
                    val -= (this.pipAddition);
                }
                this.limit = val.toFixed(this.precision_val);
                this.limit_pip = this.pip_difference;
                this.calculateLimitPip();
                if(window['myStxx'].tfc && window['myStxx'].tfc._isOpen && this.tfc){
                    window['myStxx'].tfc.addOTOLimit(this.limit);
                    // window['myStxx'].tfc.addOTOLimit(/*Number(this.price)*/)
                    // if(this.buySellType=='sell') window['myStxx'].tfc.addOTOStop()
                    // if(this.buySellType=='buy') window['myStxx'].tfc.addOTOLimit()
                }
            }
    	},
        getStep(val){
            if(this.pipSize){
                return this.pipSize
            }else{
                let data = this.instruments[this.currency_pair].A
                if(val == '' || parseFloat(val) == 0){
                    return data.toString()
                }else if(val && data.toString().includes('.')){
                    return 1/Math.pow(10, data.toString().split('.')[1].length)
                }else{
                    return '1'
                }
            }
        },
        changeValidation(variablName,val){
            let upper = 5, lower = 5;
            try{ upper = this.instruments[this.currency_pair].B.split('.')[0].length}catch(e){}
            try{ lower = this.instruments[this.currency_pair].other.Tick_Size.split('.')[1].length}catch(e){}
            this[variablName] = val.toString()
                .replace(/[^\d.]/g, '')                 // numbers and decimals only
                .replace(this.getUpper(upper+1), '$1')    // not more than 2 digits at the beginning
                .replace(/(\..*)\./g, '$1')             // decimal can't exist more than once
                .replace(this.getLower(lower), '$1');   // not more than 4 digits after decimal
        },
        getUpper(val){
            if(val == 1){ return /(^[\d]{1})[\d]/g}
            if(val == 2){ return /(^[\d]{2})[\d]/g}
            if(val == 3){ return /(^[\d]{3})[\d]/g}
            if(val == 4){ return /(^[\d]{4})[\d]/g}
            if(val == 5){ return /(^[\d]{5})[\d]/g}
            if(val == 6){ return /(^[\d]{6})[\d]/g}
            if(val == 7){ return /(^[\d]{7})[\d]/g}
            if(val == 8){ return /(^[\d]{8})[\d]/g}
            else{ return /(^[\d]{0})[\d]/g }
        },
        getLower(val){
            if(val == 1){ return /(\.[\d]{1})./g}
            if(val == 2){ return /(\.[\d]{2})./g}
            if(val == 3){ return /(\.[\d]{3})./g}
            if(val == 4){ return /(\.[\d]{4})./g}
            if(val == 5){ return /(\.[\d]{5})./g}
            if(val == 6){ return /(\.[\d]{6})./g}
            if(val == 7){ return /(\.[\d]{7})./g}
            if(val == 8){ return /(\.[\d]{8})./g}
            else{ return /(^[\d]{0})[\d]/g }
        },
        clearAdvance(){
            if(window['myStxx'] && window['myStxx'].tfc){
                window['myStxx'].tfc.closeTFC()
            }
            this.advance = false;
            this.edit_stop = false;
            this.stop = '';
            this.stop_pip = '';
            this.edit_trail = false;
            this.trail = '';
            this.edit_limit = false;
            this.limit = '';
        },
    	changeBuySell(type,clearActive = false){
    		if(this.buySellType != type){
    			this.buySellType = type
                if(clearActive){
                    this.clearAdvance();
                }
    		}
            this.modifyPending = null;
            this.changeBuyType('M')
    	},
    	getMinQuantity(){
    		
            return this.instruments[this.currency_pair].other.Min_Trade_Size
    		// 	return 1
    		// }else{
    		// 	return 0.01
    		// }
    	},
        getMinMaxQuantity(type){
            if(type) return parseFloat(this.instruments[this.currency_pair].other.Max_Trade_Size)
            else return parseFloat(this.instruments[this.currency_pair].other.Min_Trade_Size)
        },
        getMinMaxUnits(type){
            if(type) return parseFloat(this.instruments[this.currency_pair].other.Max_Trade_Size) * this.contractSize;
            else return parseFloat(this.instruments[this.currency_pair].other.Min_Trade_Size) * this.contractSize;
        },
        clearValues(){
            this.buyType = 'M'
            this.price = '';
            this.quantity = this.lot;
            this.stop = '';
            this.stop_pip = '';
            this.stop_pnl = '';
    		this.trail = '';
    		this.limit = '';
    		this.limit_pip = '';
    		this.limit_pnl = '';
    		this.edit_stop = false;
    		this.edit_trail = false;
    		this.edit_limit = false;
            this.advance = false
        },
    	clear(){
            let wsOrder = this.wsOrder
            if(this.wsOrder.hasOwnProperty(this.tempOrderId)){
                delete wsOrder[this.tempOrderId];
                // this.$store.commit('SET_WS_ORDER',wsOrder)
            }
    		this.tempOrderId = '';
    		this.orderPlacedWait = false;
    		this.price = '';
            this.marketPrice = '';
    		this.quantity = this.lot
    		this.stop = '';
    		this.stop_pip = '';
    		this.stop_pnl = '';
    		this.trail = '';
    		this.limit = '';
    		this.limit_pip = '';
    		this.limit_pnl = '';
            this.comment = '';
            this.buyType = 'M';
            this.newBuySellType = '';
            this.lastBuyType = '';
            this.newQuantity = '';
            this.newStop = '';
            this.newTrail = '';
            this.newLimit = '';
            this.advance = false
            this.orderPending = {}
    	},
    	changeBuyType(value){
            if(this.buyType == value){
                return;
            }
            if(this.buyType == 'M' && window['myStxx'] && window['myStxx'].tfc){
                window['myStxx'].tfc.closeTFC()
            }
            this.price = '';
    		this.buyType = value;
    		this.quantity = this.lot;
    		this.advance = false;
    		// this.stop = ''
            this.edit_stop = false;
            this.change_edit_stop();
    		this.trail = '';
    		// this.limit = ''
            this.edit_limit = false;
            this.change_edit_limit();
            this.comment = '';
            this.openBuySellWindow();
            
    	},
        openBuySellWindow(){
            try{
                if(window['myStxx'] && window['myStxx'].tfc && this.tfc){
                    if(window['myStxx'].tfc._isOpen){
                        // console.log('TFC---->',window['myStxx'].tfc)
                        window['myStxx'].tfc.clearActive()
                        // console.log('CIQ.Account---->',CIQ.Account.Demo.prototype)
                        const customRound = (num, direction) => {
                            return direction?(Number(num) + this.pipAddition):( num - this.pipAddition);
                        }
                        if(['S','L'].includes(this.buyType) && (!window['myStxx'].tfc.activeTrade || window['myStxx'].tfc.activeTrade == 'market')){
                            let roundUp = (this.buySellType === 'buy' && this.buyType === 'S') || (this.buySellType === 'sell' && this.buyType === 'L');
                            let windowType = this.buySellType == 'buy'?'enableBuy':'enableShort';
                            let buyType = this.buyType;
                            window['myStxx'].tfc.newTrade(windowType,customRound(this.B, roundUp))
                            this.buyType = buyType;
                            roundUp = (this.buySellType === 'buy' && this.buyType === 'S') || (this.buySellType === 'sell' && this.buyType === 'L');
                            // if(this.buySellType=='sell') roundUp=!roundUp;
                            window['myStxx'].tfc.positionCenterLine(customRound(this.B, roundUp));
                        }else if(['S','L'].includes(this.buyType)){
                            let roundUp = (this.buySellType === 'buy' && this.buyType === 'S') || (this.buySellType === 'sell' && this.buyType === 'L');
                            window['myStxx'].tfc.positionCenterLine(customRound(this.B, roundUp));
                        }else if(window['myStxx'].tfc.activeTrade ){
                            window['myStxx'].tfc.newTrade('enableEditTrade', { Side :  (this.buySellType == 'buy'?1:0) })
                            window['myStxx'].tfc.positionCenterLine(this.B);
                        }
                        
                    }else{
                        // window['myStxx'].tfc.openPanel(true);
                        document.querySelector("cq-toggle.sidebar.stx-trade").click();
                        this.openBuySellWindow()
                    }
                    // window['myStxx'].tfc.updateData();
                }
            }catch(e){ console.log('error---->',e) }
        },
        openBuySellWindowFromChart(price){
            try{
                if(window['myStxx'] && window['myStxx'].tfc && this.tfc){
                    if(window['myStxx'].tfc._isOpen){
                        // console.log('TFC---->',window['myStxx'].tfc)
                        window['myStxx'].tfc.clearActive()
                        // console.log('CIQ.Account---->',CIQ.Account.Demo.prototype)
                        function customRound(num, direction) {
                            let [intPart, decPart] = num.toString().split('.');
                            if (!decPart || decPart.length < 2) return num;
                            let change = direction? 100/decPart.length :-100/decPart.length;
                            let newDecPart = (parseFloat(decPart) + parseFloat(change)).toString().padStart(decPart.length, '0');
                            return parseFloat(`${intPart}.${newDecPart}`);
                        }
                        if(['S','L'].includes(this.buyType) && (!window['myStxx'].tfc.activeTrade || window['myStxx'].tfc.activeTrade == 'market')){
                            let windowType = this.buySellType == 'buy'?'enableBuy':'enableShort';
                            window['myStxx'].tfc.newTrade(windowType, price)
                            // let roundUp = (this.buySellType === 'sell' && this.B < this.price) || (this.buySellType === 'buy' && this.B > this.price);
                            let roundUp = (this.buySellType === 'buy' && this.buyType === 'S') || (this.buySellType === 'sell' && this.buyType === 'L');
                            // if(this.buySellType=='sell') roundUp=!roundUp
                            window['myStxx'].tfc.positionCenterLine(customRound(price, roundUp));
                        }else if(['S','L'].includes(this.buyType)){
                            // let roundUp = (this.buySellType === 'sell' && this.B < this.price) || (this.buySellType === 'buy' && this.B > this.price);
                            let roundUp = (this.buySellType === 'buy' && this.buyType === 'S') || (this.buySellType === 'sell' && this.buyType === 'L');
                            window['myStxx'].tfc.positionCenterLine(customRound(price, roundUp));
                        }
                    }else{
                        // window['myStxx'].tfc.openPanel(true);
                        document.querySelector("cq-toggle.sidebar.stx-trade").click();
                        this.openBuySellWindowFromChart(price)
                    }
                    // window['myStxx'].tfc.updateData();
                }
            }catch(e){ console.log('error---->',e) }
        },
    	placeOrder(){
            if(this.modifyPending){
                this.modifyOrder()
            }else if(this.modifyTradeDetail){
                this.modifyTrade()
            }else{
                var _that = this
                this.submitted =  true;
                this.lastBuyType = this.buyType;
                this.newQuantity = this.quantity;
                this.newLimit = this.limit;
                this.newStop = this.stop;
                this.newTrail = parseFloat(this.trail) || 0;
                this.newBuySellType = this.buySellType;
                _that.$validator.validate().then(valid => {
                    if (valid && !_that.orderPlacedWait) {
                        _that.$store.commit('SET_WS_ORDER',{})
                        const tempOrderId = new Date().getTime()
                        this.submitted =  false
                        let orderJson = {
                            "symbol" : _that.currency_pair,
                            "quantity" : parseFloat(_that.quantity),
                            "side" : (_that.buySellType == 'buy')?1:0,
                            "stop" : parseFloat(_that.stop || 0),
                            "limit" : parseFloat(_that.limit || 0),
                            "trail" : parseFloat(_that.trail || 0),
                            "commentary" : _that.comment.slice(0, 20),
                            "tempOrderId" : tempOrderId, // "account_id": this.tradingAccount[0].account_id,
                            "account_id": this.get_user.profile.act_account_id,
                            'localParams' : _that
                        }
                        _that.newQuantity = _that.quantity;
                        _that.newStop = _that.stop;
                        _that.newTrail = _that.trail;
                        _that.newLimit = _that.limit;
                        _that.orderPending = orderJson
                        _that.tempOrderId = _that.orderPending.tempOrderId
                        // if(_that.price){
                        if(_that.buyType != 'M'){
                            // console.log('order',orderJson)
                            _that.marketPrice = _that.price;
                            orderJson.price = parseFloat(_that.price)
                            _that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placepending(orderJson)
                            window['myStxx'].tfc.clearActive()
                            window['myStxx'].tfc.hideAllDOM()
                        }else{
                            _that.marketPrice = (_that.buySellType == 'buy')?_that.instruments[_that.currency_pair].A:_that.instruments[_that.currency_pair].B
                            // console.log('order',orderJson)
                            _that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeOrder(orderJson)
                            window['myStxx'].tfc.clearActive()
                            window['myStxx'].tfc.hideAllDOM()
                        }
                    }
                });
            }
    	},
    	modifyOrder(){
    		let change = false
    		var _that = this
    		this.submitted =  true
    		this.tempOrderId =  []
            let pendingOrder = this.pendingOrderList.find(v=>v.OrderID == this.modifyPending) || null;
            let lotBy = 100000;
            try{
                lotBy = this.currencyPairs.find(v=>v.mn == pendingOrder.Symbol).market_ContractSize || 100000;
            }catch(e){}
            let lot = pendingOrder.Quantity?(pendingOrder.Quantity / lotBy):0

            pendingOrder['SL'] = this.orderSL_TP(pendingOrder,'S');
            pendingOrder['TP'] = this.orderSL_TP(pendingOrder,'L');
            pendingOrder['Trail'] = this.getTrail(pendingOrder.OrderID);

            this.lastBuyType = pendingOrder.Type == 'ES'?'S':pendingOrder.Type == 'EL'?'L':'';
            let price = this.price;
            let quantity = this.quantity;
            let limit = this.limit;
            let edit_limit = this.edit_limit;
            let stop = this.stop;
            let edit_stop = this.edit_stop;
            let trail = this.trail;
            let edit_trail = this.edit_trail;

            this.marketPrice = price;
            this.newQuantity = quantity;
            this.newLimit = limit;
            this.newStop = stop;
            this.newTrail = parseFloat(trail) || 0;
            this.newBuySellType = this.buySellType;
            // return;
    		_that.$validator.validate().then(valid => {
				if (valid && !_that.orderPlacedWait) {
					_that.$store.commit('SET_WS_ORDER',{})
	    			_that.submitted =  false
					
					if(pendingOrder.Trail.Trail && !edit_trail){
						_that.cancelOrder(pendingOrder.Trail)
						change = true
	    			}else if(trail && trail != pendingOrder.Trail.Trail){
		    			const tempOrderId = new Date().getTime() + '_trail'
						let orderJson = {
							"order" : pendingOrder.OrderID,
							"trade" : '',
							"trail" : parseFloat(trail),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeTrail(orderJson)
						change = true;
					}
					if(pendingOrder.SL.Price && !edit_stop && !pendingOrder.Trail.Trail){
	    				_that.cancelOrder(pendingOrder.SL,'SL')
	    				change = true
	    			}else if(stop && stop != pendingOrder.SL.Price){
		    			const tempOrderId = new Date().getTime() + '_stop'
						let orderJson = {
							"order" : pendingOrder.OrderID,
							"trade" : '',
							"price" : parseFloat(stop),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						_that.tempOrderId.push(orderJson.tempOrderId);
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placestop(orderJson)
						change = true
                        // console.log('stop-change===========>',_that.stop)
					}

					if(pendingOrder.TP.Price && !edit_limit){
						_that.cancelOrder(pendingOrder.TP,'TP')
						change = true
	    			}else if(limit && limit != pendingOrder.TP.Price){
                        const tempOrderId = new Date().getTime() + '_limit'
						let orderJson = {
							"order" : pendingOrder.OrderID,
							"trade" : '',
							"price" : parseFloat(limit),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeLimit(orderJson)
						change = true
					}

                    if(price && price != pendingOrder.Price || lot != quantity){
		    			const tempOrderId = new Date().getTime() + '_Price_lot'
						let orderJson = {
							"order_id" : pendingOrder.OrderID,
							"symbol" : _that.currency_pair,
							"quantity" : parseFloat(quantity),
							"price" : parseFloat(price),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].modifyOrder(orderJson)
						change = true
					}
					if(!change){
						_that.displayError('Please Make changes before Modify Order','error')
						return
					}
					_that.placed = true;
				}
			});
    	},
        modifyTrade(){
            let change = false
    		var _that = this
    		this.submitted =  true
    		this.tempOrderId =  []
            this.lastBuyType = 'M';
            let quantity = this.quantity;
            let limit = this.limit;
            let edit_limit = this.edit_limit;
            let stop = this.stop;
            let edit_stop = this.edit_stop;
            let trail = this.trail;
            let edit_trail = this.edit_trail;

            this.marketPrice = this.modifyTradeDetail.Price;
            this.newQuantity = quantity;
            this.newLimit = limit;
            this.newStop = stop;
            this.newTrail = parseFloat(trail) || 0;
            this.newBuySellType = this.buySellType;
            this.sl_canceled = '';
            this.tp_canceled = '';

    		_that.$validator.validate().then(valid => {
				if (valid && !_that.orderPlacedWait) {
					this.$store.commit('SET_WS_ORDER',{})
	    			_that.submitted =  false;
                    if(_that.modifyTradeDetail.Trail.Trail && !edit_trail){
						change = true
                        _that.cancelOrder(_that.modifyTradeDetail.Trail)
                    }else if(trail && trail != _that.modifyTradeDetail.Trail.Trail){
						const tempOrderId = new Date().getTime() + '_trail'
						let orderJson = {
							"trade" : _that.modifyTradeDetail.TradeID,
							"order" : '',
							"trail" : parseFloat(trail || 0),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeTrail(orderJson)
						change = true
					}
                    
	    			if(_that.modifyTradeDetail.SL.Price && !edit_stop && !_that.modifyTradeDetail.Trail.Trail){
                        _that.cancelOrder(_that.modifyTradeDetail.SL,'SL')
                        change = true
	    			}else if(stop && stop != _that.modifyTradeDetail.SL.Price){
						const tempOrderId = new Date().getTime() + '_stop'
						let orderJson = {
							"trade" : _that.modifyTradeDetail.TradeID,
							"order" : '',
							"price" : parseFloat(stop || 0),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						// console.log('place stop',orderJson)
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placestop(orderJson)
						change = true
					}

					if(_that.modifyTradeDetail.TP.Price && !edit_limit){
						_that.cancelOrder(_that.modifyTradeDetail.TP,'TP')
						change = true
	    			}else if(limit && limit != _that.modifyTradeDetail.TP.Price){
                        const tempOrderId = new Date().getTime() + '_limit'
						let orderJson = {
							"trade" : _that.modifyTradeDetail.TradeID,
							"order" : '',
							"price" : parseFloat(limit || 0),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeLimit(orderJson)
						change = true
                        
					}
					if(!change){
						_that.displayError('Please Make changes before Modify Order','error')
						return
					}
					_that.placed = true
				}
            });
        },
        orderSL_TP(list,type){
    		try{
    			let close = this.pendingOrderList.filter(val=>(val.ToClose == list.OpenOrderID || val.TradeID == list.OrderID || val.ToClose == list.OrderID || val.OpenOrderID == list.OrderID || val.OpenTime == list.OpenTime) && val.Type == type)
    			return (close.length)?close[0]:{}
    		}catch(e){return {}}
    	},
    	getTrail(TradeID){
    		try{
    			let close = this.pendingOrderList.filter(val=> (val.TradeID == TradeID || val.ToClose == TradeID || val.OpenOrderID == TradeID) && val.Type == 'S')
    			return (close.length)?close[0]:{}
    		}catch(e){return {}}
    	},
    	successWs(){
            let _that = this;
            clearTimeout(successTimeout);
            successTimeout = setTimeout(()=>{
                this.orderPlacedWait = true
                this.closeOrderWindow();
                _that.clearAdvance();
            },200)
			// alert(123)
			/*console.log('order placed')
			let _that = this
			let Timer = setInterval(function(){
				let orderMessage = localStorage.getItem('orderMessage')
				if(orderMessage){
					let data = JSON.parse(orderMessage)
					console.log('data',data)
					if(data.tempOrderId == _that.orderPending.tempOrderId){
						console.log('data',data,'true')
						_that.orderPlacedWait = false
						_that.displayError(data.resp_msg,'success')
						_that.orderStatusRecived = data;
						_that.step = '2'
						localStorage.removeItem('orderMessage');
						clearInterval(Timer);
					}
				}
			}, 500);*/
        },
        failedWs(){
			this.orderPending = '';
			this.tempOrderId = '';
			this.displayError('failed to Place order','error')
            // console.log('failed')
        },
        displayError(getMessage,type){
			this.$notify({
				group: 'foo',
				type: (type && type == null)?'error':type,
				text: getMessage,
				duration: 2000,
				closeOnClick: true
			});
		},
        changePrice(movePrice){
            // console.log(window['myStxx'].tfc.activeTrade,this.buyType)
            // console.log(window['myStxx'].tfc)
            let buySellType = window['myStxx'].tfc.activeTrade
            if(buySellType && buySellType != "market"/* && this.buyType != 'M'*/){
                if(window['myStxx'].tfc.modifyingOrder && window['myStxx'].tfc.modifyingOrder.id){
                    if(this.modifyPending != window['myStxx'].tfc.modifyingOrder.id){
                        this.clear();
                        this.modifyPending = window['myStxx'].tfc.modifyingOrder.id;
                        let pendingOrder = this.pendingOrderList.find(v=>v.OrderID == this.modifyPending) || null;
                        let stop = this.orderSL_TP(pendingOrder,'S').Price || '';
                        let limit = this.orderSL_TP(pendingOrder,'L').Price || '';
                        let trail = this.getTrail(pendingOrder.OrderID).Trail || '';
                        let lotBy = 100000;
                        try{
                            lotBy = this.currencyPairs.find(v=>v.mn == pendingOrder.Symbol).market_ContractSize || 100000;
                        }catch(e){}
                        this.quantity = pendingOrder.Quantity?(pendingOrder.Quantity / lotBy):0
                        if(stop || limit || trail){
                            this.advance = true;
                            if(trail){
                                this.trail = trail;
                                this.edit_trail = true;
                            }else{
                                if(stop){
                                    this.edit_stop = true
                                    this.stop = stop;
                                    this.calculateStopPip()
                                    window['myStxx'].tfc.addOTOStop(Number(stop))
                                }else{
                                    this.edit_stop = false;
                                    this.stop = '';
                                    this.stop_pip = '';
                                }
                                this.edit_trail = false;
                            }
                            if(limit){
                                this.edit_limit = true
                                this.limit = limit;
                                this.calculateLimitPip();
                                window['myStxx'].tfc.addOTOLimit(Number(limit))
                            }
                        }
                        this.buyType = ''
                    }
                }else{
                    this.modifyPending = null;
                }
                if(this.buyType != 'M'){
                    if(movePrice != this.price){
                        this.price = movePrice
                    }
                    if(buySellType != this.buySellType){
                        this.buySellType = buySellType == 'short'?'sell':buySellType;
                    } 
                    if(this.buySellType == 'sell'){
                        if(this.B > this.price && this.buyType != 'S'){
                            this.buyType = 'S';
                        }else if(this.B < this.price && this.buyType != 'L'){
                            this.buyType = 'L';
                        }
                    }else if(this.buySellType == 'buy'){
                        if(this.B > this.price && this.buyType != 'L'){
                            this.buyType = 'L';
                        }else if(this.B < this.price && this.buyType != 'S'){
                            this.buyType = 'S';
                        }
                    }
                }
            }/*else if(this.buyType != 'M'){
                this.changeBuyType('M')
            }*/
        },
        changeMarket(){
            if(this.buyType == 'M'/* && !this.positionDetails*/){
                if(window['myStxx'].tfc.centerPrice != this.B){
                    // console.log(window['myStxx'].tfc.centerPrice,this.B)
                    window['myStxx'].tfc.positionCenterLine(this.B);
                }
            }
        }
    },
    computed:{
        isTempIdInWS(){
            if(Array.isArray(this.tempOrderId)){
                let isTemp = (this.tempOrderId.filter(v=>this.wsOrder.hasOwnProperty(v)) || []).length > 0
                if(isTemp){
                    this.tempOrderId.forEach(v=>{
                        if( this.wsOrder.hasOwnProperty(v) && this.wsOrder[v].stat == "NOK" && ['stop','limit'].includes(v.split('_')[1]) ){
                            if(v.includes('stop')){
                                console.log('stop',v,this.wsOrder)
                                this.newStop = '0.00';
                            }else if(v.includes('limit')){
                                this.newLimit = '0.00';
                                console.log('limit',v,this.wsOrder)
                            }
                        }
                    })
                }
                return isTemp
            }else{
                return this.wsOrder.hasOwnProperty(this.tempOrderId)
            }
        },
        contractSize(){
            return (this.currencyPairs.find(v=> v.mn == this.currency_pair) || {}).market_ContractSize || 10000;
        },
        precision_val(){
            return (((this.instrument.other.Tick_Size || '').split('.')[1] || '').length) || 1
        },
        SPREAD(){
            return Number(this.instrument.SPREAD || 0)
        },
        A(){
            return Number(this.instrument.A || 0).toFixed((((this.instrument.other.Tick_Size || '').split('.')[1] || '').length) || 1)
        },
        B(){
            return Number(this.instrument.B || 0).toFixed((((this.instrument.other.Tick_Size || '').split('.')[1] || '').length) || 1)
        },
    	instrument(){
            return this.instruments[this.currency_pair] || {}
        },
        currency(){
            let currencyIcon = { EUR: "€", USD: "$", CAD: "CA$", BTC: "₿", GBP: "£", CHF: "CHF", JPY: "¥", AUD: "A$" };
            return currencyIcon[this.accountList.Currency]
        },
    	instruments(){
    	    try {                    
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {                
	            return {}
	        }
	    },
        pipAddition(){
            return Number(this.instrument.other.pip_size || 0)*this.pip_difference;
        },
        pipSize(){
            return Number(this.instrument.other.pip_size || 0);
        },

    },
    updated(){
        // $(document).ready(function () {
        //     $('.decimal-restrict').on('input', function () {
        //         // Get the current value of the input
        //         let value = $(this).val();

        //         // Sanitize the value to allow only one decimal point
        //         let sanitizedValue = value
        //         .replace(/[^0-9.]/g, "") // Remove all non-numeric and non-dot characters
        //         .replace(/(\..*?)\..*/g, "$1"); // Keep only the first decimal point

        //         // Set the sanitized value back to the input
        //         $(this).val(sanitizedValue);
        //     });
        // });
        let _that = this;
        // Select all input fields with the class "ABC"
        const inputFields = document.querySelectorAll('.no-price-update');

        inputFields.forEach((input) => {
            // Listen for focus event
            input.addEventListener('focus', () => {
                _that.isPriceActive = true;
            });

            // Listen for blur event
            input.addEventListener('blur', () => {
                _that.isPriceActive = false;
            });
        });
    },
    mounted(){
        if (this.currency_pair && this.instruments && this.instruments[this.currency_pair] && this.accountList && this.accountList.Currency) {
            this.convertCurrencyUnified(this.accountList.Currency, this.instruments[this.currency_pair], this.instruments, product, product_type);
        }

        let _that = this
        /*$("input").keypress(function(e){
            console.log('Enter pressed',e,e.which )
            if(e.which == 10 || e.which == 13) {
                _that.placeOrder();
            }
          // $("span").text(i += 1);
        });
        $('input').keypress(function(e) {
            // Enter pressed?
            console.log('Enter pressed')
        });*/

        if(this.tfc){
            TFC.prototype.positionCenterLine = function (price, keepOnChart) {
                if (keepOnChart !== false) keepOnChart = true;
                // console.log('positionCenterLine---->',price)
                //Added this code to link to the outside inputs
                const movePrice = Number(parseFloat(price).toFixed(_that.precision_val));
                _that.changePrice(movePrice)
                /*let quantity = this.quantityFromValue(this.elements.limitShares.value);
                if(quantity && quantity != _that.quantity){
                    _that.quantity = quantity
                }else if(_that.quantity && quantity != _that.quantity){
                    window['myStxx'].tfc.changeQuantity()
                }*/
                //End of custom code
                // console.log('----------movePrice------------>',movePrice)
                this.centerPrice = movePrice;
                this.positionAtPrice( this.centerPrice, ["limitOrder", "dragLineCenter"], "center", null, keepOnChart );
                this.elements.dragLineCenterPrice.innerHTML = this.formatPrice(
                    this.centerPrice
                );

                let orderT=''
                if(_that.buyType=='L') orderT='LIMIT';
                else if(_that.buyType=='S') orderT='STOP';

                // position_size : _that.userSettings.position_size,
                                // market_ContractSize : (_that.otherListObj[v.Symbol] || {}).market_ContractSize,

                let qty = _that.userSettings.position_size == '1'? _that.units : _that.quantity;

                this.elements.cancelDescription.innerHTML = (_that.buySellType || '').toUpperCase()+" "+orderT+" "+qty+ " @"+ movePrice

                this.elements.dragLineCenterPrice.innerValue = this.formatInnerValue(
                    this.centerPrice
                );
                this.positionBelowLine(Math.min(this.centerPrice, this.belowPrice));
                this.positionAboveLine(Math.max(this.centerPrice, this.abovePrice));
            };
            TFC.prototype.changeQuantity = function () {
                // console.log(this.elements.limitShares)
                CIQ.setValueIfNotActive(this.elements.limitShares, CIQ.commas(_that.quantity));
            };
            TFC.prototype.updateBelowLocal = function (price, keepOnChart) {
                if(price && keepOnChart){
                    _that.changeMarket()
                    const movePrice = parseFloat(price).toFixed(_that.precision_val);
                    if(!_that.advance){
                        _that.advance = true
                    }
                    if(_that.buySellType == 'buy'){
                        if(!_that.edit_stop){
                            _that.edit_stop = true
                        }
                        if(_that.stop != movePrice) 
                            _that.stop = movePrice;
                            _that.calculateStopPip();
                    }else if(_that.buySellType == 'sell'){
                        if(!_that.edit_limit){
                            // alert("edit limti true in below local")
                            _that.edit_limit = true
                        }
                        if(_that.limit != movePrice) 
                            _that.limit = movePrice;
                            _that.calculateLimitPip()
                    }
                }
            };
            TFC.prototype.updateAboveLocal = function (price, keepOnChart) {
                if(price && keepOnChart){
                    _that.changeMarket()
                    const movePrice = parseFloat(price).toFixed(_that.precision_val);
                    if(!_that.advance){
                        _that.advance = true
                    }
                    if(_that.buySellType == 'sell'){
                        if(!_that.edit_stop){
                            _that.edit_stop = true
                        }
                        if(_that.stop != movePrice) 
                            _that.stop = movePrice;
                            _that.calculateStopPip();
                    }else if(_that.buySellType == 'buy'){
                        if(!_that.edit_limit){
                            _that.edit_limit = true
                        }
                        if(_that.limit != movePrice) 
                            _that.limit = movePrice;
                            _that.calculateLimitPip();
                    }
                }
            };
            TFC.prototype.removeStopLimit = function (remove) {
                if(remove=='stop') {
                    _that.edit_stop = false;
                    _that.stop = ''
                    _that.stop_pip = ''
                }
                if(remove=='limit'){
                    _that.edit_limit = false;
                    _that.limit = '';
                    _that.limit_pip = '';
                }
            };
            TFC.prototype.closedTrack = function () {
                // // console.log('--------------------->',window['myStxx'].tfc);
                if((_that.modifyTradeDetail && _that.positionDetails) || (_that.modifyOrderDetail && _that.modifyPending)){
                    _that.$emit('clearTrade');
                    _that.changeBuySell('buy',true)
                }
                _that.modifyPending = null;
                _that.positionDetails = null;
                _that.clearValues()
                // _that.changeBuySell('buy');
            };
            TFC.prototype.modifyOpenOrderSelf = function (openOrder) {
                // console.log('modifyOpenOrder-------',openOrder)
                //var position=this.account.positions[this.stx.chart.symbol];
                //var quantity=0;
                //if(position) quantity=position.quantity;
                // var openOrder = openOrder;
                this.modifyingOrder = openOrder; // Use this when submitting the modification

                this.renderOpenOrders(); // this will hide the now modifyingOrder

                // Now enable the trade components to modify this order

                this.setActiveInput("shares"); // Trigger updates to dollar values
                this.dom.limitOrder.classList.add("tfc-cancel");
                if (openOrder.action == "buy" || openOrder.action == "cover") {
                    this.elements.limitReplace.classList.add("green");
                } else {
                    this.elements.limitReplace.classList.remove("green");
                }
                this.elements.cancelDescription.innerHTML = this.createDescription(openOrder);
                if (openOrder.action == "buy") {
                    // console.log('modifyOpenOrder-buy',openOrder)
                    this.newTrade("enableBuy", { openOrder: openOrder });
                } else if (openOrder.action == "cover") {
                    this.newTrade("enableCover", { openOrder: openOrder });
                } else if (openOrder.action == "sell") {
                    this.newTrade("enableSell", { openOrder: openOrder });
                } else if (openOrder.action == "short") {
                    this.newTrade("enableShort", { openOrder: openOrder });
                }
                if (openOrder.oto) {
                    // Enable and position the OTO elements, if any
                    if (openOrder.action == "buy") {
                        this.activeTrade = "buy";
                    } else {
                        this.activeTrade = "short";
                    }
                    for (var i = 0; i < openOrder.oto.length; i++) {
                        var order = openOrder.oto[i];
                        if (order.stop) {
                            this.addOTOStop(order.stop);
                        } else if (order.limit) {
                            this.addOTOLimit(order.limit);
                        }
                    }
                }
                if (this.account.config.disableModifyOrderQuantity) {
                    this.elements.limitCurrency.readOnly = false;
                    this.elements.limitShares.readOnly = false;
                }
            };
        }
	},
    created(){
        // if(this.userSettings.lotsize){
        //     this.quantity = this.userSettings.lotsize
        //     this.lot = this.userSettings.lotsize
        // }else{
        //     this.quantity = this.instruments[this.currency_pair].other.Min_Trade_Size
        //     this.lot = this.instruments[this.currency_pair].other.Min_Trade_Size
        // }
        if(this.userSettings.lotsize && this.userSettings.lotsize >= this.instruments[this.currency_pair].other.Min_Trade_Size){
            this.quantity = this.userSettings.lotsize
            this.lot = this.userSettings.lotsize
        }else{
            this.quantity = this.instruments[this.currency_pair].other.Min_Trade_Size
            this.lot = this.instruments[this.currency_pair].other.Min_Trade_Size
        }
        // this.quantity = this.instruments[this.currency_pair].other.Min_Trade_Size
        // this.lot = this.instruments[this.currency_pair].other.Min_Trade_Size
    	// this.$store.commit('SET_WS_ORDER',{})
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/user/home-elements/buy-sell-tabing.vue